<template>
  <div>
    <div v-show="!signLayer">
      <div v-if="!sidExpired" class="singVerify">
        <div v-if="!singVerifySuccess" class="signVerify-body">
          <img class="tiao"  src="@/assets/images/sign/tiao.png" alt="">
          <img class="zhutiImg" src="@/assets/images/app/hetongzhuti.png" alt="">

          <van-form colon class="signVerify-form" >
            <div style="color: #415273;font-size: 15px;font-weight: 500;margin-bottom: 10px">
              {{singVerifyForm.taskName}}
            </div>
            <van-field
                v-model="singVerifyForm.initiatorName"
                label="发起方"
                readonly
                label-width="50"
            />
            <van-field
                label="签署方"
                readonly
                label-width="50"
            >
              <template #input>
                <span v-if="singVerifyForm.signSubject=='company'">{{singVerifyForm.signerName}}({{singVerifyForm.companyName}})</span>
                <span v-else>{{singVerifyForm.signerName}}</span>
              </template>
            </van-field>

          </van-form>
        </div>
        <div v-if="!singVerifySuccess" class="signVerify-footer">
          <div v-if="signStatus=='iSign'" class="authWaysBox">
           <van-form >
             <div v-if="singVerifyForm.authWaysValue=='sms'"  class="authWaysBox-title">短信验证</div>
             <div v-if="singVerifyForm.authWaysValue=='pin'"  class="authWaysBox-title">签署密码验证</div>
             <div v-if="singVerifyForm.authWaysValue=='live'"  class="authWaysBox-title">刷脸验证</div>
<!--             短信验证-->
             <van-field
                 v-if="singVerifyForm.authWaysValue=='sms'"
                 v-model="singVerifyForm.phone"
                 label="验证码将发送至您的手机:"
                 readonly
                 label-width="180"
                 style="margin-bottom: 16px"
                 :border="false"
             />
             <van-field
                 v-if="singVerifyForm.authWaysValue=='sms'"
                 v-model.trim="singVerifyForm.vcode"
                 center
                 clearable
                 class="sms-input"
                 :border="false"
             >
               <template #input>
                 <van-field :border="false" v-model="singVerifyForm.vcode" type="digit" placeholder="请输入验证码" maxlength="6"/>
                 <div class="code-btn">
                   <span class="right-btn"  type="info" :disabled="!sendCode"
                         @click="getMsgAuthCode" v-show="sendCode">获取验证码</span>
                   <span type="info" v-show="!sendCode" class="right-btn">
                     重新获取({{ auth_time }})秒</span>
                 </div>
               </template>
             </van-field>
             <div v-show="singVerifyForm.authWaysValue=='sms' && sendCodeAlert" class="alert">{{sendCodeAlertMsg}}</div>
<!--签署密码-->
             <van-field
                 v-if="singVerifyForm.authWaysValue=='pin'"
                 label="请输入签署密码"
                 readonly
                 label-width="180"
                 style="margin-bottom: 16px"
                 :border="false"
             />
             <van-field
                 v-if="singVerifyForm.authWaysValue=='pin'"
                 center
                 class="sms-input"
                 :border="false"
             >
               <template #input>
                 <van-field :border="false" v-model="singVerifyForm.pin" :type="showPasswordType" placeholder="请输入签署密码" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')"/>
                 <div class="code-icon">
                   <img v-show="isShowPassword" class="icon" src="@/assets/images/unifysign/eye.png" alt="" @click="isShowPassword=false">
                   <img v-show="!isShowPassword" class="icon-noeye" src="@/assets/images/unifysign/noeye.png" alt=""  @click="isShowPassword=true">
                 </div>
               </template>
             </van-field>
             <div v-show="singVerifyForm.authWaysValue=='pin' && pinAlert" class="alert">{{pinAlertMsg}}</div>

             <van-button block v-if="singVerifyForm.authWaysValue=='sms' " :disabled="!singVerifyForm.vcode" class="signVerifySubmitBtn" type="info" @click="singVerifyFormSubmit(singVerifyForm.authWaysValue)">确认</van-button>
             <van-button block v-if="singVerifyForm.authWaysValue=='pin'" :disabled="!singVerifyForm.pin"  class="signVerifySubmitBtn" type="info" @click="singVerifyFormSubmit(singVerifyForm.authWaysValue)">确认</van-button>
<!--刷脸验证-->

             <div class="liveBox" v-if="singVerifyForm.authWaysValue=='live'">
               <p>请<span style="color: #3F7BF9">{{singVerifyForm.signerName}}</span>本人进行人脸识别验证</p>
               <img src="@/assets/images/app/head.png" alt="">
             </div>
             <van-button block v-if="singVerifyForm.authWaysValue=='live'" class="signVerifySubmitBtn" type="info" @click="singVerifyFormSubmit(singVerifyForm.authWaysValue)">去认证</van-button>

           </van-form>
            <div class="otherAuthWay" v-if="singVerifyForm.authWaysArr && singVerifyForm.authWaysArr.length>1">
              <div class="otherAuthWay-head">
                <div class="line"></div>
                <div class="title">其他验证方式</div>
                <div class="line"></div>
              </div>
              <div class="otherAuthWay-body">
                <span  v-for="(item,index) in singVerifyForm.authWaysArr" :key="index">
                    <span v-if="singVerifyForm.authWaysValue!='sms' && item.label=='sms'" @click="authWaysChange(item.label)" style="margin-left: 20px">
                      <img  class="img" src="@/assets/images/unifysign/duanxin.png" alt="">
                      <span class="txt">短信验证</span>
                   </span>
                    <span v-if="singVerifyForm.authWaysValue!='pin'  && item.label=='pin'" @click="authWaysChange(item.label)" style="margin-left: 20px">
                      <img  class="img" src="@/assets/images/unifysign/suo.png" alt="">
                      <span  class="txt">签署密码验证</span>
                   </span>
                    <span v-if="singVerifyForm.authWaysValue!='live'  && item.label=='live'" @click="authWaysChange(item.label)" style="margin-left: 20px">
                        <img  class="img" src="@/assets/images/unifysign/shualian.png" alt="">
                        <span  class="txt">刷脸验证</span>
                    </span>
                 </span>

              </div>
            </div>
          </div>
          <div class="wancheng" v-if="signStatus=='finish'">
            <img src="@/assets/images/unifysign/wancheng.png" alt="">
            <div class="txt">
              签署已完成
            </div>
            <div>
              <van-button  v-if="singVerifyForm && singVerifyForm.returnUrl"  class="fanhui" type="info"  @click="handleBackHome">返回</van-button>
            </div>
          </div>
          <div class="wancheng" v-if="signStatus=='expire'">
            <img src="@/assets/images/unifysign/guoqi.png" alt="">
            <div class="txt">
              签署已过期
            </div>
            <div>
              <van-button v-if="singVerifyForm && singVerifyForm.returnUrl"  class="fanhui" type="info" @click="handleBackHome">返回</van-button>
            </div>
          </div>
        </div>

      </div>
      <div v-if="sidExpired" class="sidExpired">
        <img src="@/assets/images/unifysign/guoqi.png" alt="">
        <div class="txt">
          签署页面已失效
        </div>

      </div>
    </div>
    <div v-show="signLayer" id="sign-layer">
      <div class="showTasks" @click="showTaskList">
        <!--      <img src="@/assets/images/down-icon.png" alt="">-->
        <div class="left">
          <img src="@/assets/images/app/file.png" alt="">
          <span>{{fileName}}</span>
        </div>
        <div class="right">
          <span>切换文件({{active+1}}/{{signFileInfoArray.length}})</span>
          <img src="@/assets/images/app/downIcon.png" alt="">
        </div>
      </div>
      <div class="fenye">{{fenyeInfoNum}}</div>
      <div style="width: 100%;height: 42px"></div>
      <van-popup v-model="showTasksStatus" position="top" :style="{ height: '4.9rem' }">
        <div class="closeTasks" @click="closeTaskList">
          <img :style="{'transform':showTasksStatus? 'rotate(0deg)' :'rotate(180deg)'}" src="@/assets/images/down-icon.png" alt="">
        </div>
        <div class="task-list">
          <van-radio-group v-model="active">
            <van-cell-group>
              <van-cell :title="file.fileName" clickable @click="selectTask(index)"
                        v-for="(file, index) in signFileInfoArray" :key="index" class="vanCellItem">
                <template #right-icon>
                  <van-radio :name="index" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-popup>
      <van-overlay :show="signLoading" :zIndex="9999" :custom-style="{ backgroundColor: 'rgba(255,255,255,1)' }">
        <van-loading size="28px" text-size="16px" vertical color="#0094ff">签署中...</van-loading>
      </van-overlay>

      <div class="contract-wrap">
        <div class="seal-group-wrap">
          <div class="seal-group">
            <div class="seal-item" v-for="element in sealOutArray" :key="element.sealId">
              <span class="seal-title">{{ element.sealName }}</span>
              <draggable chosenClass="chosen" :sort="false" forceFallback="true" allbackOnBody="true"
                         animation="400">
                <transition-group>
                  <img :src="element.sealImg" alt="" class="drag-box" :key="element.sealId"
                       :data-seal-type="element.sealType" :data-seal-id="element.sealId">
                </transition-group>
              </draggable>
            </div>
            <div class="seal-item" v-if="needHandwritten">
              <span class="seal-title">制作签名</span>
              <van-button round icon="plus" class="handwrite-add-btn" size="small"
                          @click="handleNewHandwrite"></van-button>
              <!-- <draggable chosenClass="chosen" :sort="false" forceFallback="true" allbackOnBody="true"
              animation="400" @start="onSealOutStart" @end="onSealOutEnd($event, selfHandwriteSeal)"
              @touchstart="onSealOutStart" v-else>
              <transition-group>
                  <img :src="selfHandwriteSeal.sealImg" alt="" class="drag-box" :key="selfHandwriteSeal.key"
                      :data-seal-type="selfHandwriteSeal.sealType" :data-seal-id="selfHandwriteSeal.sealId">
              </transition-group>
          </draggable>
          <van-button round icon="delete-o" class="handwrite-remove-btn" size="small" v-if="selfHandwriteSeal"
              @click="handleRemoveHandwrite"></van-button> -->

            </div>
            <div class="seal-item auto-seal-btn-wrap" v-if="positonExistFlag">
              <van-button plain type="info" @click="handleAutoSeal">一键盖章</van-button>
            </div>

          </div>
        </div>
        <div class="contract-content" ref="contractImg" id="contract-imgs">
          <div v-for="(item, idx) in signFileInfoArray" :key="idx" v-show="idx == active" class="file-item">
            <div class="img-wrap" v-for="(contract, index) in item.fileImgArray" :key="index" ref="imgWrap" @click="">
              <img :src="contract.src" class="contract-img" alt="" @click="imgWrap" />
              <div v-for="(pos, posIdx) in contract.poss"
                   :key="pos.positionId + posIdx">
                <div class="position-box" :data-pos-id="pos.positionId" :data-seal-type="pos.sealType"
                     :data-page-idx="index" :data-type="pos.sealLocationType" :style="{
                                    left:
                                        pos.sealLocationType == 'paging'
                                            ? 'unset'
                                            : (pos.positionX / 50000).toFixed(4) * 100 + '%',
                                    top: (pos.positionY / 50000).toFixed(4) * 100 + '%',
                                    right: pos.sealLocationType == 'paging' ? '0' : 'unset',
                                }"
                     v-if="pos.sealLocationType == 'paging' || (pos.sealLocationType != 'paging' && pos.positionPage == (index + 1))"
                     @click="handleCoverSeal(pos, $event)"
                >
                  <div v-if="
                                    pos.sealType == 'companyCommon' &&
                                    pos.sealLocationType == 'position'
                                " class="seal-pos-box">
                    <div class="box-head">企业章</div>
                  </div>
                  <div v-if="
                                    pos.sealType == 'companyLegal' &&
                                    pos.sealLocationType == 'position'
                                " class="companyLegal-pos-box">
                    <div class="box-head">法定代表人章</div>
                  </div>
                  <div v-if="
                                    pos.sealType == 'person' &&
                                    pos.sealLocationType == 'position'
                                " class="sign-pos-box">
                    <div class="box-head">个人签名</div>
                  </div>
                  <div v-if="
                                    pos.sealType == 'date' &&
                                    pos.sealLocationType == 'position'
                                " class="date-pos-box">
                    <div class="box-head">日期章</div>
                  </div>
                  <div v-if="pos.sealLocationType == 'paging'" class="paging-pos-box">
                    <div class="box-head">骑缝章</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <draggable  v-model="sealInArray" v-if="!positonExistFlag" class="drag-overlay" :sort="false"
                     chosenClass="chosen" forceFallback="true" allbackOnBody="true" animation="400"
                     @start="onSealInStart" @move="onSealInMove" @end="onSealInEnd">
            <transition-group>
              <div class="seal-in drag-box" v-for="(element, eleIdx) in sealInArray"
                   :key="element.dragKey"
                   :data-key="element.dragKey"
                   :data-type="element.dataType"
                   :data-range-start="element.rangeStart"
                   :data-range-end="element.rangeEnd"
                   :data-seal-type="element.sealType"
                   :data-seal-id="element.dataSealId"
                   :data-file="element.dataFile"
                   :style="{ left: element.left + 'px', top: element.top + 'px' }"
                   v-show="element.show && (element.fileIdx == active)">
                <img :src="element.sealImg" alt="">

                <van-icon name="close" color="#ee0a24" size="16"
                          @touchstart.prevent.stop="handleRemoveSealInItem(element,eleIdx)" />
              </div>

            </transition-group>
          </draggable>
        </div>



      </div>
      <div class="bottom-btn" v-if="positonExistFlag">
        <van-button type="default" class="btn gaizhang" @click="handleAutoSeal">一键盖章</van-button>
        <van-button type="info" class="btn" @click="hanleSaveFun" :disabled="signStatus != 'iSign'">确认签署</van-button>
      </div>
      <div class="bottom-btn" v-if="!positonExistFlag">
        <van-button type="info" class="btn queren" @click="hanleSaveFun" :disabled="signStatus != 'iSign'">确认签署</van-button>
      </div>


      <!--上下页-->
      <div class="page-indicator" v-if="signFileInfoArray[active]" v-show="signFileInfoArray[active].filePages > 1">
        <div class="page-icon" @click="handlePageUp" v-show="signFileInfoArray[active].current != 0" >
          <svg-icon class="page-icon-inner" iconClass="page-up" width="16" height="16"></svg-icon>
          <svg-icon class="page-icon-inner active" iconClass="page-up-active" width="16" height="16"></svg-icon>
        </div>
        <div class="page-icon" @click="handlePageDown"
             v-show="signFileInfoArray[active].current != signFileInfoArray[active].fileImgArray.length - 1">
          <svg-icon class="page-icon-inner" iconClass="page-down" width="16" height="16"></svg-icon>
          <svg-icon class="page-icon-inner active" iconClass="page-down-active" width="16" height="16"></svg-icon>
        </div>
      </div>


      <!--指定位置时 未签章的数量-->
      <el-popover placement="bottom-end" width="180" trigger="hover" popper-class="light-popper"
                  v-if="countPositionSealList[active] && showLocatePopover && notSealCount && positonExistFlag">
        <p>共有{{ notSealCount }}个待签署未处理，点击快速定位</p>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="showLocatePopoverFalse">不再提示</el-button>
        </div>
        <div class="locate-indicator" slot="reference" @click="handleQuickLocateNotSeal">
          <div class="locate-icon">
            <svg-icon class="locate-icon-inner" iconClass="locate" width="22" height="22"></svg-icon>
            <svg-icon class="locate-icon-inner active" iconClass="locate-active" width="22"
                      height="22"></svg-icon>
          </div>
          <span class="badge" v-if="countPositionSealList[active] && notSealCount">{{ notSealCount }}</span>
        </div>
      </el-popover>
      <!--          未指定签署位置的时候-->
      <el-popover placement="bottom-end" width="180" trigger="hover" popper-class="light-popper"
                  v-if="!positonExistFlag && showLocatePopoverNew">
        <p>共签署{{ sealCount }}个章，点击快速定位</p>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="showLocatePopoverTrue">不再提示</el-button>
        </div>
        <div class="locate-indicator" id="locateIndicator" slot="reference" @click="handleQuickLocateSeal">
          <div class="locate-icon">
            <svg-icon class="locate-icon-inner" iconClass="locate" width="22" height="22"></svg-icon>
            <svg-icon class="locate-icon-inner active" iconClass="locate-active" width="22"
                      height="22"></svg-icon>
          </div>
          <span class="badge" v-if="sealCount">{{ sealCount }}</span>
        </div>
      </el-popover>



      <!--指定位置时  一键盖章弹窗-->
      <van-action-sheet class="autoSealDialog" v-model="showAutoSeal" title="" :close-on-click-overlay="false">
        <div slot="description" class="head">
          <div class="left">
            <span class="txt">选择签章</span>
          </div>
          <div class="right">
            <span @click="showAutoSeal=false">X</span>
          </div>
        </div>
        <div class="auto-seal-wrap">
          <div v-for="(arr, key) in sealInfoArrayMapAutoSeal" :key="key" style="width: 100%">
            <div class="set-title">
              <svg-icon iconClass="bar" width="2" height="12" style="margin-right: 8px;"></svg-icon>
              <span v-if="key == 'companyCommon'">企业章</span>
              <span v-if="key == 'person'">个人签名</span>
              <span v-if="key == 'companyLegal'">法定代表人章</span>
              <span v-if="key == 'companyAgent'">经办人签名</span>
              <span v-if="key == 'date'">日期章</span>
            </div>


            <div class="auto-seal-list">
              <div v-for="item in arr" :key="item.sealId" style="width: 45%">
                <div class="auto-seal-item" @click="handleSelectAutoSeal(item, arr)"
                     :class="{ 'isCheck': item.check }">
                  <div>
                    <div class="auto-seal-item-box" data-type="sign" :data-seal-type="item.sealType" :data-seal-id="item.sealId">
                      <img :src="item.sealImg" alt="" ondragstart="return false" />
                    </div>
                    <img src="@/assets/images/app/checkedIcon.png" class="check-icon" v-if="item.check" alt="">
                  </div>
                </div>
                <div class="seal-title">
                  <span>{{item.sealName}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gutter"></div>
        <div class="footer">
          <van-button type="info" @click="handleCheckAutoSeal" block class="auto-seal-sure-btn">确 定</van-button>
        </div>
      </van-action-sheet>

      <!--    指定位置时 点击章的位置 选择章的弹窗-->
      <van-action-sheet v-model="showCoverSeal" title="" :close-on-click-overlay="false" closeable class="coverSealDialog">
        <div slot="description" class="head">
          <div class="left">
            <span class="txt">{{ sealInfoArrayMapAutoSealTitle}}</span>
            <van-checkbox class="checkbox" icon-size="16px" v-model="togetherSealChecked" shape="square">同时加盖全部签署位置</van-checkbox>
          </div>
          <div class="right">
            <span @click="showCoverSeal=false">X</span>
          </div>
        </div>
        <div class="auto-seal-wrap">
          <div v-for="(arr, key) in sealInfoArrayMapAutoSeal" :key="key" style="width: 100%">
            <div class="auto-seal-list">
              <div v-for="item in arr" :key="item.sealId" style="width: 45%">
                <div class="auto-seal-item" @click="handleSelectAutoSeal(item, arr)"
                     :class="{ 'isCheck': item.check }">
                  <div>
                    <div class="auto-seal-item-box" data-type="sign" :data-seal-type="item.sealType" :data-seal-id="item.sealId">
                      <img :src="item.sealImg" alt="" ondragstart="return false" />
                    </div>
                    <img src="@/assets/images/app/checkedIcon.png" class="check-icon" v-if="item.check" alt="">

                  </div>
                </div>
                <div class="seal-title">
                  <span>{{item.sealName}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gutter"></div>
        <div class="footer">
          <van-button type="info" @click="handleCheckCoverSeal" block class="auto-seal-sure-btn">确 定</van-button>
        </div>
      </van-action-sheet>


      <!--未指定位置时  选择签章弹窗-->
      <van-action-sheet class="noLocationSealDialog" v-model="showSealNoLocation" title="" :close-on-click-overlay="false" >
        <div slot="description" class="head">
          <div class="left">
            <span class="txt">选择签章</span>
          </div>
          <div class="right">
            <span @click="showSealNoLocation=false">X</span>
          </div>
        </div>
        <div class="auto-seal-wrap">
          <div v-for="(arr, key) in sealInfoArrayMapAutoSeal" :key="key" style="width: 100%">
            <div class="set-title">
              <svg-icon iconClass="bar" width="2" height="12" style="margin-right: 8px;"></svg-icon>
              <span v-if="key == 'companyCommon'">企业章</span>
              <div v-if="key == 'companyCommon'"  class="qifengSwitch">
                <el-popover
                    placement="bottom-start"
                    width="200"
                    trigger="hover"
                    content="打开骑缝章开关后，拖拽到文档中的【企业章】将自动在文档所有页右侧加盖骑缝章。">
                  <i slot="reference" class="el-icon-warning-outline" style="font-size: 14px;color: #A6ACB4"></i>
                </el-popover>
                <span style="margin-left:8px;margin-right: 8px;font-size: 14px" placement="bottom-end">骑缝章</span>
                <van-switch v-model="isPaging" size="20px" />
              </div>
              <span v-if="key == 'person'">个人签名</span>
              <span v-if="key == 'companyLegal'">法定代表人章</span>
              <span v-if="key == 'companyAgent'">经办人签名</span>
              <span v-if="key == 'date'">日期章</span>
            </div>


            <div class="auto-seal-list">
              <div v-for="item in arr" :key="item.sealId" style="width: 45%">
                <div class="auto-seal-item" @click="handleSelectSealNoLocation(item, arr,sealInfoArrayMapAutoSeal)"
                     :class="{ 'isCheck': item.check }">
                  <div>
                    <div class="auto-seal-item-box" data-type="sign" :data-seal-type="item.sealType" :data-seal-id="item.sealId" >
                      <img :src="item.sealImg" alt="" ondragstart="return false" />
                    </div>
                    <img src="@/assets/images/app/checkedIcon.png" class="check-icon" v-if="item.check" alt="">
                    <img v-if="isPaging && item.sealType=='companyCommon'" class="qifeng" src="@/assets/images/unifysign/qifeng.png" alt="">

                  </div>
                </div>
                <div class="seal-title">
                  <span>{{item.sealName}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gutter"></div>
        <div class="footer">
          <van-button type="info" @click="handleCheckNoLocationSeal" block class="auto-seal-sure-btn">确 定</van-button>
        </div>
      </van-action-sheet>


    </div>
    <van-overlay :show="loading" :zIndex="9999" :custom-style="{ backgroundColor: 'rgba(255,255,255,1)' }">
      <van-loading size="28px" text-size="16px" vertical color="#0094ff">加载中...</van-loading>
    </van-overlay>


<!--签署意愿后认证弹窗-->
    <van-dialog
        class="authMethodType-dialog"
        v-model="authMethodTypeVisible"
        :show-confirm-button="false"
       >

      <div class="dialog-title">
        <span>签署意愿验证</span>
        <span @click="authMethodTypeVisible=false">x</span>
      </div>
      <div class="dialog-content">
        <van-form class="authMethodType-form">

          <template v-for="(item,index) in singVerifyForm.authWaysArr">
<!--            短信验证-->
            <template v-if="authMethodType=='sms' && item.label=='sms'">
              <van-field
                  label="验证码将发送至您的手机:"
                  readonly
                  :border="false"
                  label-width="180"
                  style="margin-top: 8px"
              />
              <van-field
                  v-model="singVerifyForm.phone"
                  readonly
                  :border="false"
                  style="margin-top: 8px"
              />
              <van-field
                  v-model.trim="singVerifyForm.vcode"
                  center
                  clearable
                  class="sms-input"
                  style="margin-top: 8px"

              >
                <template #input>
                  <van-field :border="false" v-model="singVerifyForm.vcode" type="digit" placeholder="请输入验证码" maxlength="6"/>
                  <div class="code-btn">
                   <span class="right-btn"  type="info" :disabled="!sendCode"
                         @click="getMsgAuthCode" v-show="sendCode">获取验证码</span>
                    <span type="info" v-show="!sendCode" class="right-btn">
                     重新获取({{ auth_time }})秒</span>
                  </div>
                </template>
              </van-field>
              <div v-show="sendCodeAlert" class="alert">{{sendCodeAlertMsg}}</div>
              <van-button block :disabled="!singVerifyForm.vcode" class="signVerifySubmitBtn" type="info" @click="singVerifyFormSubmitAfter(authMethodType)">确认</van-button>
            </template>

<!--            签署密码验证-->
            <template v-if="authMethodType=='pin' && item.label=='pin'">
              <van-field
                  label="请输入签署密码"
                  readonly
                  :border="false"
                  label-width="180"
                  style="margin-bottom: 12px"
              />
              <van-field
                  center
                  class="sms-input"
                  :border="false"
              >
                <template #input>
                  <van-field :border="false" v-model.trim="singVerifyForm.pin" :type="showPasswordType" placeholder="请输入签署密码" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" />
                  <div class="code-icon">
                    <img v-show="isShowPassword" class="icon" src="@/assets/images/unifysign/eye.png" alt="" @click="isShowPassword=false">
                    <img v-show="!isShowPassword" class="icon-noeye" src="@/assets/images/unifysign/noeye.png" alt=""  @click="isShowPassword=true">
                  </div>
                </template>
              </van-field>
              <div v-show="pinAlert" class="alert">{{pinAlertMsg}}</div>

              <van-button block :disabled="!singVerifyForm.pin" class="signVerifySubmitBtn" type="info" @click="singVerifyFormSubmitAfter(authMethodType)">确认</van-button>
            </template>

<!--            刷脸验证-->
            <template v-if="authMethodType=='live' && item.label=='live'">

              <div class="liveBox">
                <p>请<span style="color: #3F7BF9">{{singVerifyForm.signerName}}</span>本人进行人脸识别验证</p>
                <img src="@/assets/images/app/head.png" alt="">
              </div>
              <van-button block class="signVerifySubmitBtn" type="info" @click="singVerifyFormSubmitAfter(authMethodType)">去认证</van-button>



            </template>

          </template>
          <van-divider v-if="singVerifyForm.authWaysArr && singVerifyForm.authWaysArr.length>1" :style="{fontSize:'12px', padding: '0 16px' }">
            其他验证方式
          </van-divider>
          <div class="otherAuthWay-body" >
                <span  v-for="(item,index) in singVerifyForm.authWaysArr" :key="index">
                    <span v-if="authMethodType!='sms' && item.label=='sms'" @click="authMethodTypeFun(item.label)" style="margin-left: 20px">
                      <img  class="img" src="@/assets/images/unifysign/duanxin.png" alt="">
                      <span class="txt">短信验证</span>
                   </span>
                    <span v-if="authMethodType!='pin'  && item.label=='pin'" @click="authMethodTypeFun(item.label)" style="margin-left: 20px">
                      <img  class="img" src="@/assets/images/unifysign/suo.png" alt="">
                      <span  class="txt">签署密码验证</span>
                   </span>
                    <span v-if="authMethodType!='live'  && item.label=='live'" @click="authMethodTypeFun(item.label)" style="margin-left: 20px">
                        <img  class="img" src="@/assets/images/unifysign/shualian.png" alt="">
                        <span  class="txt">刷脸验证</span>
                    </span>
                 </span>

          </div>
        </van-form>
      </div>
    </van-dialog>


  </div>

</template>

<script>
import { Button,
  Form,
  Field,
  Icon,
  Popup,
  RadioGroup,
  Radio,
  ActionSheet,
  Overlay,
  Loading,
  Uploader,
  Checkbox,
  DatetimePicker,
  Image,
  NavBar,
  Picker,
  Calendar,
  Cell,
  CellGroup,
  PasswordInput,
  NumberKeyboard,
  Dialog,
  Tab,
  Tabs,
  Swipe,
  SwipeItem,
  Tabbar,
  TabbarItem,
  Toast,
  List,
  PullRefresh,
  Badge,
  DropdownMenu,
  DropdownItem,Switch,Divider} from 'vant';
import { Notify } from "vant";
import draggable from "vuedraggable";
import { getSignInfoPcAndH5, signPcAndH5, checkHandwrite,getTaskInfo } from "@/api/unifysign/sign";
import {getStyle} from "@/utils/animte";
import {getAuthTokenByPinOpen, getAuthTokenBySmsVerificationCodeOpen, getSmsVerificationCode} from "@/api/sign/sign";
export default {

  data() {
    return {
      loading:false, //加载中
      dragging: false,
      //定义要被拖拽对象的数组
      sealOutArray: [],
      sealInArray: [],
      dragSealInfo: {
        startX: 0,
        startY: 0,
        EndX: 0,
        EndY: 0,
        offsetX: 60,
        offsetY: 0
      },
      contractImgScrollTop: 0,

      positonExistFlag: undefined,
      active: 0,
      lastActive: 0,
      signFileInfoArray: [],
      judgeScope: 30,
      // selfHandwriteSeal: null,
      needHandwritten: false,
      signLoading: false,
      showTasksStatus: false,
      signId: "",
      signAuthToken: "",

      showAutoSeal: false,
      sealInfoArrayMapAutoSeal: {},
      signStatus: undefined,



      showKeyboard: false,
      value: "",
      showDialog: true,
      authSuccess: false,

      showPinKeyboard: false,
      pinValue: "",
      showPinDialog: false,
      authPinSuccess: false,

      userPhone: "",
      // auth_time: 60 * 3,
      sendAuthCode: true,

      agreementChecked: false,
      countPositionSealList: [], // 落章统计
      scrollWatchStatus: true,
      showLocatePopover: true,
      locatePositionBoxByStepIdx: -1, // 初始值是-1 因为每点一次会自增
      sealCount:0,//未定位时已拖章的数量
      showLocatePopoverNew:true,
      locateNotPositionBoxByStepIdx:-1,

      showCoverSeal:false,//指定位置  选择签章 弹窗
      sealInfoArrayMapAutoSealTitle:'',
      togetherSealChecked:false,//是否同时加盖全部签署位置
      checkedSealPositionLocationType:undefined, //指定位置 弹窗盖章 点击印章的类型
      checkedSealPositionSealType:undefined,//指定位置 弹窗盖章 点击印章的类型
      notSealCount:0, //指定位置时 未盖章的数量
      fileName:'',//选中的文件名称
      fenyeInfoNum:"",
      taskName: "",
      authStep:undefined,//认证时机：签署前：before签署时：after 不认证：not

      handleSaveDialogVisible:true,//签署时的提示框
      handleSaveDialogMsg:"",//提示框内容

     signLayer:true,// 合同状态时finish或者expired  false
      sidExpired:false,//sid 是否过期
      singVerifySuccess:false,//是否验证通过
      singVerifyForm:{
        vcode:'',//短信验证码
        pin:'',//签署密码

      },//认证前后 弹窗内容

      sendCode:true, //
      sendCodeAlert:false,
      sendCodeAlertMsg:"",
      pinAlert:false,
      pinAlertMsg:"", //提示信息
      qrcodeUrl:'',//刷脸二维码
      qrCodeStatus:'',//二维码状态
      authId:'',//刷脸二维码 认证ID
      getFaceAuthResultTimer:undefined,
      auth_time: 60,
      isShowPassword:false,//显示隐藏密码框
      singVerifySuccess_time:2, //验证通过倒计时
      authMethodType:'sms',//签署后的验证弹窗  sms 短信验证  pin 签署密码验证 live 刷脸验证

      showSealNoLocation:false,
      checked:false,

      originTargetLeft:0,//点击屏幕时 触点横轴
      originTargetTop:0, //点击屏幕时 触点竖轴
      originTargetOffsetY:0,

      isPaging:false,//收否勾选骑缝章
      authMethodTypeVisible:false,//后验证弹窗


    };
  },
  computed: {
    contractImgs() {
      if (this.signFileInfoArray[this.active]) {
        return this.signFileInfoArray[this.active].fileImgArray;
      } else {
        return [];
      }
    },
    // notSealCount() {
    //   console.log("###############")
    //   if (this.countPositionSealList[this.active]) {
    //     return this.countPositionSealList[this.active].filter(_ => {
    //       return !_.sealId
    //     }).length;
    //   } else {
    //     return ""
    //   }
    //
    // },
    showPasswordType(){
      return this.isShowPassword ? 'text' : 'password'
    },
  },
  created() {
    this.sid = this.$route.query.sid;
    this.getTaskInfoApi()
    document.title = "电子签章";
  },
  mounted() {
    // document.querySelector(".seal-group").addEventListener(
    // 	"touchmove",
    // 	function(e) {
    // 		e.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
    // 	},
    // 	{ passive: false }
    // );
    var dom=document.createElement('style');
    dom.innerHTML="html{font-size:50px}";
    document.head.appendChild(dom)
    window.addEventListener("scroll", this.scrollEventHandler, true);
    document.body.addEventListener("click", this.highlightEventHandler, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollEventHandler, true);
    window.removeEventListener("click", this.highlightEventHandler, true);
  },
  methods: {
    imgWrap(e){
      console.log("dafdafsdf")
      let sealInfoArrayCopy = JSON.parse(JSON.stringify(this.sealOutArray));
      let arrayMap = {};
      sealInfoArrayCopy.map(item => {
        item.check = false;
        if (!arrayMap[item.sealType]) {
          arrayMap[item.sealType] = [item]
        } else {
          arrayMap[item.sealType].push(item)
        }
      })
      this.sealInfoArrayMapAutoSeal = arrayMap;

    //点击的位置
      this.originTargetLeft=e.clientX;
      this.originTargetTop=e.clientY;
      this.originTargetOffsetY=e.offsetY;
      this.showSealNoLocation=true;


    },
    getTaskInfoApi(){
      getTaskInfo({
        sid: this.sid
      }).then(res => {
        if(res.code!=200){
          if(res.code==5002){
            this.signLayer=false;
            this.sidExpired=true;
          }else{
            Notify({
              type: "warning",
              message: res.message
            });
          }
          return
        }else {

          this.taskName=res.data.taskName;
          //
          this.authStep=res.data.authStep;
          //签署状态
          this.signStatus=res.data.signStatus;

          this.singVerifyForm=res.data;

          if(this.signStatus=="finish" || this.signStatus=="expire"){
            this.signLayer=false;
            return;
          }
          switch (this.authStep){
              //签署前认证
            case 'before':
              this.signLayer=false;
              // this.singVerifyForm=res.data;
              this.singVerifyForm.authWaysValue=res.data.authWays[0] || 'sms';
              // this.singVerifyForm.authWaysValue= 'live';
              this.singVerifyForm.authWaysArr=[];

              res.data.authWays.map(item=>{
                let value="";
                if(item=='sms'){
                  value="短信验证"
                }else if(item=="pin"){
                  value="签署密码验证"
                }else if(item=="live"){
                  value="刷脸验证"
                }
                let obj={
                  label:item,
                  value:value
                }
                this.singVerifyForm.authWaysArr.push(obj)

              })

              break
              //签署后认证
            case 'after':
              // this.signLayer=false;
              this.singVerifyForm=res.data;
              this.singVerifyForm.authWaysValue=res.data.authWays[0] || 'sms' //测试代码
              this.singVerifyForm.authWaysArr=[];
              this.authMethodType=res.data.authWays[0];
              res.data.authWays.map(item=>{
                let obj={
                  label:'',
                  value:'',
                }
                let value="";
                obj.label=item;
                if(item=='sms'){
                  // value="短信验证"
                  obj.value="短信验证";
                }else if(item=="pin"){
                  obj.value="签署密码验证"
                }else if(item=="live"){
                  obj.value="刷脸验证"
                }

                this.singVerifyForm.authWaysArr.push(obj)

              })
              //  获取详情
              if(this.signStatusDialog!="finish" && this.signStatusDialog!="expire"){
                this.handleGetSignDetailInfo()
              }
              break
            default:
              this.handleGetSignDetailInfo()
              break
          }
        }
      }).catch((err) => {
        this.loaded = true;
      });
    },
    initTask() {
      this.handleGetSignDetailInfo();
      this.getUserAccountInfo();
    },

    //获取验证码
    getMsgAuthCode() {
      this.auth_time = 60;
      this.sendCode = false;
      getSmsVerificationCode({
        sid: this.sid,
      }).then((res) => {
        if (res.code != "200") {
          if(res.code==5002){
            this.signLayer=false;
            this.sidExpired=true;
          }else{
            Notify({
              message: res.message,
              type: "danger",
            });
          }

          this.sendCode = true;
          this.auth_time = 60;
        } else {
          Notify({
            message: "短信发送成功",
            type: "success",
          });
          // 倒计时
          this.auth_time = 60;
          var auth_timetimer = setInterval(() => {
            this.auth_time--;
            if (this.auth_time < 1) {
              this.sendCode = true;
              clearInterval(auth_timetimer);
            }
          }, 1000);
        }
      })
          .catch((err) => {
            console.log(err);
            // this.$message.error('服务器错误！');
          });
    },
    //认证弹窗  提交
    singVerifyFormSubmit(authWays){
      switch (authWays) {
          //短信认证
        case 'sms':
          if(!this.singVerifyForm.vcode){
            Notify({
              type: "warning",
              message: "请输入短信验证码!"
            });
            return
          }
          getAuthTokenBySmsVerificationCodeOpen({
            vcode: this.singVerifyForm.vcode,
            sid:this.sid
          }).then(res=>{
            if (res.code != "200") {
              if(res.code==5001){
                this.sendCodeAlert=true;
                this.sendCodeAlertMsg=res.message;
              }else if(res.code==5002){
                this.signLayer=false;
                this.sidExpired=true;
              }else{
                Notify({
                  type: "warning",
                  message: res.message
                });
              }
            } else {
              this.sendCodeAlert=false;
              //意愿认证token
              this.authToken=res.data.authToken;
              this.singVerifySuccess=true;
              this.singVerifySuccess_time = 2;
              var singVerifySuccess_timer = setInterval(() => {
                this.singVerifySuccess_time--;
                if (this.singVerifySuccess_time < 1) {
                  clearInterval(singVerifySuccess_timer);
                  this.signLayer=true;
                }
              }, 1000);
              if(this.authStep=='before'){
                this.handleGetSignDetailInfo();
              }
            }
          }).catch((err) => {
            // this.$message.error('服务器错误！');
          });
          break
        case 'pin':
          if(!this.singVerifyForm.pin){
            Notify({
              type: "warning",
              message: "请输入签署密码!"
            });
            return
          }
          getAuthTokenByPinOpen({
            pin:this.singVerifyForm.pin,
            sid:this.sid
          }).then(res=>{
            if (res.code != "200") {
              if(res.code==5001){
                this.pinAlert=true;
                this.pinAlertMsg=res.message;
              }else if(res.code==5002){
                this.signLayer=false;
                this.sidExpired=true;
              }else{
                Notify({
                  type: "warning",
                  message: res.message
                });
              }
            } else {
              this.pinAlert=false;
              //意愿认证token
              this.authToken=res.data.authToken;
              this.singVerifySuccess=true;
              this.singVerifySuccess_time = 2;
              var singVerifySuccess_timer = setInterval(() => {
                this.singVerifySuccess_time--;
                if (this.singVerifySuccess_time < 1) {
                  clearInterval(singVerifySuccess_timer);
                  this.signLayer=true;
                }
              }, 1000);
              if(this.authStep=='before'){
                this.handleGetSignDetailInfo();
              }
            }
          })
          break
      }

    },
    //签署后认证弹窗  提交
    singVerifyFormSubmitAfter(authWays){
      switch (authWays) {
          //短信认证
        case 'sms':
          if(!this.singVerifyForm.vcode){
            Notify({
              type: "warning",
              message: "请输入短信验证码!"
            });
            return
          }
          getAuthTokenBySmsVerificationCodeOpen({
            vcode: this.singVerifyForm.vcode,
            sid:this.sid
          }).then(res=>{
            if (res.code != "200") {
              if(res.code==5001){
                this.sendCodeAlert=true;
                this.sendCodeAlertMsg=res.message;
              }else if(res.code==5002){
                this.signLayer=false;
                this.sidExpired=true;
              }else{
                Notify({
                  type: "warning",
                  message: res.message
                });
              }
            } else {
              this.sendCodeAlert=false;
              //意愿认证token
              this.authToken=res.data.authToken;

              this.authMethodTypeVisible=false;
              this.handleSave();
            }
          }).catch((err) => {
            // this.$message.error('服务器错误！');
          });
          break
        case 'pin':
          if(!this.singVerifyForm.pin){
            Notify({
              type: "warning",
              message: "请输入签署密码!",
            });
            return
          }
          getAuthTokenByPinOpen({
            pin:this.singVerifyForm.pin,
            sid:this.sid
          }).then(res=>{
            if (res.code != "200") {
              if(res.code==5001){
                this.pinAlert=true;
                this.pinAlertMsg=res.message;
              }else if(res.code==5002){
                this.signLayer=false;
                this.sidExpired=true;
              }else{
                Notify({
                  type: "warning",
                  message: res.message,
                });
              }
            } else {
              this.pinAlert=false;
              //意愿认证token
              this.authToken=res.data.authToken;
              this.authMethodTypeVisible=false;
              this.handleSave();
            }
          })
          break
      }

    },
    //验证前切换验证方式
    authWaysChange(val){
      this.singVerifyForm.authWaysValue=val;
      this.$set(this.singVerifyForm,"authWaysValue",val)
      this.sendCodeAlert=false;
      this.pinAlert=false;
      this.$forceUpdate();
      //清楚刷脸轮训的定时器
      if (this.getFaceAuthResultTimer) {
        clearInterval(this.getFaceAuthResultTimer);
        this.getFaceAuthResultTimer = null;
      }
      //刷脸
      if(val=='live'){
        // this.getFaceAuthLinkStillApi();
      }
    },
    //切换验证方式
    authMethodTypeFun(authMethodType){
      this.authMethodType=authMethodType;
      this.sendCodeAlert=false;
      this.pinAlert=false;
      //清楚刷脸轮训的定时器
      if (this.getFaceAuthResultTimer) {
        clearInterval(this.getFaceAuthResultTimer);
        this.getFaceAuthResultTimer = null;
      }
      //刷脸
      if(authMethodType=='live'){
        // this.getFaceAuthLinkStillApi();
      }
    },
    //指定位置时 点击印章方法
    handleCoverSeal(pos,e){
      if(pos.sealType=='companyCommon' && pos.sealLocationType == 'position'){
        this.sealInfoArrayMapAutoSealTitle="企业章"
      }else if(pos.sealType=='companyLegal' && pos.sealLocationType == 'position'){
        this.sealInfoArrayMapAutoSealTitle="法定代表人章"
      }else if(pos.sealType=='companyAgent' && pos.sealLocationType == 'position'){
        this.sealInfoArrayMapAutoSealTitle="经办人签名"
      }else if(pos.sealType=='person' && pos.sealLocationType == 'position'){
        this.sealInfoArrayMapAutoSealTitle="个人签名"
      }else if(pos.sealType=='date' && pos.sealLocationType == 'position'){
        this.sealInfoArrayMapAutoSealTitle="日期章"
      }else if(pos.sealLocationType == 'paging'){
        this.sealInfoArrayMapAutoSealTitle="骑缝章"
      }
      this.checkedSealPositionLocationType=pos.sealLocationType;
      this.checkedSealPositionSealType=pos.sealType;
      let sealInfoArrayCopy = JSON.parse(JSON.stringify(this.sealOutArray));
      let arrayMap = {};
      sealInfoArrayCopy.map(item => {
        item.check = false;
        //如果是骑缝章
        if(pos.sealLocationType=='paging'){
          if(item.sealType=="companyCommon"){
            if (!arrayMap[item.sealType]) {
              arrayMap[item.sealType] = [item]
            } else {
              arrayMap[item.sealType].push(item)
            }
          }
        }else{
          if(item.sealType==pos.sealType){
            if (!arrayMap[item.sealType]) {
              arrayMap[item.sealType] = [item]
            } else {
              arrayMap[item.sealType].push(item)
            }
          }
        }
      })
      this.sealInfoArrayMapAutoSeal = arrayMap;
      this.showCoverSeal=true;
    },
    // 指定位置时 盖章逻辑
    handleCheckCoverSeal() {
      this.sealInArray = [];
      let checkedSealList = [];
      const contractDom = document.querySelector(".contract-content");

      // 清空之前手动盖上的章
      // if (contractDom.querySelectorAll(".drag-box").length) {
      //   Array.from(contractDom.querySelectorAll(".drag-box")).forEach(item => {
      //     item.parentNode.parentNode.removeChild(item.parentNode);
      //   });
      // }
      Object.keys(this.sealInfoArrayMapAutoSeal).map(key => {
        this.sealInfoArrayMapAutoSeal[key].map(item => {
          if (item.check) {
            item.node = document.querySelector(".seal-group").querySelector(`.drag-box[data-seal-id="${item.sealId}"]`);
            // item.node = document.querySelector(".auto-seal-wrap").querySelector('.auto-seal-item.isCheck').querySelector(`.auto-seal-item-box[data-seal-id="${item.sealId}"]`);
            checkedSealList.push(item);
          }
        })
      })
      if(!checkedSealList.length){
        Notify({
          type: "warning",
          message: "请选择印章"
        });
        return
      }

      let positionBoxList = Array.from(document.querySelectorAll(".position-box"));

      checkedSealList.map(item => {
        positionBoxList.map(nodeItem => {
          //如果点击的是骑缝章
          if(this.checkedSealPositionLocationType=="paging"){
            // 如果勾选全部盖章
            if(this.togetherSealChecked){
              if (nodeItem.getAttribute("data-seal-type") == item.sealType) {
                this.checkedSealPositionBoxFun(nodeItem,item,contractDom)
              }
            }else{
              if (nodeItem.getAttribute("data-seal-type") == item.sealType && nodeItem.getAttribute("data-type")=="paging") {
                this.checkedSealPositionBoxFun(nodeItem,item,contractDom)
              }
            }
          }else{
              // 如果勾选全部盖章
            if(this.togetherSealChecked){
              if (nodeItem.getAttribute("data-seal-type") == item.sealType ) {
                this.checkedSealPositionBoxFun(nodeItem,item,contractDom)
              }
            }else{
              if (nodeItem.getAttribute("data-seal-type") == item.sealType && nodeItem.getAttribute("data-type")!="paging") {
                this.checkedSealPositionBoxFun(nodeItem,item,contractDom)
              }
            }
          }
        })
      })
      this.showCoverSeal = false;
    },
    checkedSealPositionBoxFun(nodeItem,item,contractDom){

      // 更新签框统计数组
      this.countPositionSealList[this.active].find(_item => {
        return _item.positionId === nodeItem.getAttribute("data-pos-id")
      }).sealId = item.sealId;
      this.notSealCount=this.notSealCountFun();

      let itemNodeClone = item.node.cloneNode(true);
      const posType = nodeItem.getAttribute("data-type");
      const pageIdx = nodeItem.getAttribute("data-page-idx");
      const posId = nodeItem.getAttribute("data-pos-id");
      const cloneWrapDom = document.createElement("div");
      cloneWrapDom.style.position = "relative";
      cloneWrapDom.style.left = "unset";
      cloneWrapDom.style.top = "unset";
      const deleteDom = document.createElement("i");
      deleteDom.setAttribute(
          "class",
          "van-icon van-icon-close"
      );
      deleteDom.addEventListener("click", (e) => {
        e.stopPropagation();
        if (posType == 'paging') {
          // 删除所有相同id的骑缝章
          const targetPagingId = posId;
          const allTargetPagingDoms = contractDom.querySelectorAll(".file-item")
              [this.active].querySelectorAll(
              '.position-box[data-pos-id="' +
              targetPagingId +
              '"] .drag-box'
          );
          for (let i = 0; i < allTargetPagingDoms.length; i++) {
            allTargetPagingDoms[i].parentNode.parentNode.parentNode.classList.remove("has-seal");
            allTargetPagingDoms[i].parentNode.parentNode.removeChild(
                allTargetPagingDoms[i].parentNode
            );
          }

        } else {
          cloneWrapDom.parentNode.parentNode.classList.remove("has-seal");
          cloneWrapDom.parentNode.removeChild(cloneWrapDom);
        }
        const sealPosItemIdx = this.sealInArray.findIndex(_item => {
          return _item.positionId == posId;
        })
        if (sealPosItemIdx >= 0) {
          this.sealInArray.splice(sealPosItemIdx, 1);
        }
        // 更新签框统计数组
        this.countPositionSealList[this.active].find(item => {
          return item.positionId === posId;
        }).sealId = null;
        this.notSealCount=this.notSealCountFun();
      });
      cloneWrapDom.appendChild(deleteDom);
      cloneWrapDom.appendChild(itemNodeClone);
      if (nodeItem.querySelector(".drag-box")) {
        nodeItem.querySelector(".drag-box").parentNode.parentNode.removeChild(nodeItem.querySelector(".drag-box").parentNode);
      }
      nodeItem.classList.add("has-seal");
      nodeItem.lastElementChild.appendChild(cloneWrapDom);
      let handleSeal = {
        show: true,
        positionId: posId,
        sealId: item.sealId,
        sealType: item.sealType
      };

      if (posType != 'paging' || (posType == 'paging' && pageIdx == 0)) {
        this.sealInArray.push(handleSeal);
      }
    },
    notSealCountFun(){
      if (this.countPositionSealList[this.active]) {
        return this.countPositionSealList[this.active].filter(_ => {
          return !_.sealId
        }).length;
      } else {
        return ""
      }
    },
    showTaskList() {
      this.showTasksStatus = true;
    },
    closeTaskList() {
      this.showTasksStatus = false;
    },
    selectTask(index) {
      this.active = this.lastActive = index;
      this.fileName=this.signFileInfoArray[index].fileName;
      // this.signFileInfoArray[this.active].current = 0;
      this.$set(this.signFileInfoArray[this.active],"current",0);
      this.notSealCount=this.notSealCountFun();
      document.getElementsByClassName("contract-content")[0].scrollTo({
        top: 0, behavior: 'smooth'
      });
      this.showTasksStatus=false;
    },
    /**
     *@method judgePage
     *@description 判定落在哪页，只针对 top 值
     *@param {Object} target 判定目标 dom 对象
     *@param {Number} targetTop 判定目标 dom 对象 top 值
     *@param {Number} pageHeight 外层 dom 对象高度
     *@param {Number} offsetHeight 判定目标 dom 对象高度
     *@return {Object} target
     */
    judgePage(target, targetTop, pageHeight, offsetHeight) {
      let gutterHeight = +window
          .getComputedStyle(document.querySelectorAll(".img-wrap")[0], null)
          .marginBottom.split("px")[0];
      // 判定范围
      const judgeScope = (offsetHeight - gutterHeight) / 2 + gutterHeight;
      const judgeExpression =
          targetTop -
          (Math.ceil(targetTop / (pageHeight + gutterHeight)) *
              (pageHeight + gutterHeight) -
              (gutterHeight + offsetHeight) / 2);
      // 多页计算

      let divider = target.page;
      divider = Math.floor(targetTop / (pageHeight + gutterHeight));
      if (divider < 0) {
        divider = 0;
        target.top = 0;
      } else {
        if (Math.abs(judgeExpression) < judgeScope) {
          // 进入判定范围
          // const nextPageHeight =
          //     (pageHeight + gutterHeight) *
          //     Math.ceil(targetTop / (pageHeight + gutterHeight));
          if (judgeExpression <= 0) {
            // 移到上一页
            target.top = pageHeight * (divider + 1) + gutterHeight * divider - offsetHeight;
          } else {
            // 移到下一页
            divider++;
            target.top = (pageHeight + gutterHeight) * divider;
            // target.top = 0;

          }
        }
      }
      if (divider > this.contractImgs.length - 1) {
        divider = this.contractImgs.length - 1;
        target.top = pageHeight * (divider + 1) + gutterHeight * divider - offsetHeight;
      }
      target.page = divider;
      target.absTop = divider < 1 ? target.top : (target.top - (pageHeight + gutterHeight) * divider);
      return target;
    },
    //获取详情
    handleGetSignDetailInfo() {
      this.loading=true;
      getSignInfoPcAndH5({
        authToken:this.authToken,
        sid: this.sid,
      }).then((res) => {
        if (res.code != "200") {
          if(res.code==5002){
            this.signLayer=false;
            this.sidExpired=true;
          }else{
            Notify({
              message: res.message,
              type: "warning",
            });
          }
        } else {
          //是否指定了盖章位置
          this.positonExistFlag = res.data.positonExist === "yes";
          this.signStatus = res.data.signStatus;
          // this.signFileInfoArray = res.data.signFileInfoArray;
          this.fileName=res.data.signFileInfoArray[0].fileName;
          this.sealOutArray = res.data.sealInfoArray;
          this.needHandwritten = res.data.needHandwritten == "yes";


          const countPositionSealList = [];
          res.data.signFileInfoArray.map((item, idx) => {
            let pushArr = [];
            if (item.filePositionArray && Array.isArray(item.filePositionArray)) {
              countPositionSealList[idx] = [];
              countPositionSealList[idx].push(...item.filePositionArray);
              item.filePositionArray.map((posItem) => {
                if (posItem.sealLocationType == "paging") {
                  posItem.positionPage = 1;
                  for (let i = 2, len = item.filePages; i <= len; i++) {
                    pushArr.push({
                      positionId: posItem.positionId,
                      positionPage: i,
                      positionY: posItem.positionY,
                      sealType: posItem.sealType,
                      sealLocationType: "paging",
                    });
                  }
                }
              });
              item.filePositionArray.push(...pushArr);
              item.filePositionArray.map(posItem => {
                posItem.sealId = null;
              })
            }
            item.current = 0;
            item.fileImgArray = item.fileImgArray.map((imgItem, imgIdx) => {
              let poss;
              if (item.filePositionArray) {
                poss = item.filePositionArray.filter((posItem) => {
                  return posItem.positionPage - 1 == imgIdx;
                });
              }
              let obj = {};
              obj.src = imgItem;
              if (!this.signSucceed) {
                obj.poss = poss;
              }
              return obj;
            });
          });
          this.signFileInfoArray = res.data.signFileInfoArray;

          // 每一次拖入签章都更新该数组，删除签章同理
          this.countPositionSealList = countPositionSealList;
          this.notSealCount=this.notSealCountFun();
          this.lastActive = this.active;
          this.fenyeInfoNum="1/"+this.signFileInfoArray[this.active].fileImgArray.length;

        }
        setTimeout(()=>{
          this.loading=false;
        },1000)
      });
    },
    //确认签署
    hanleSaveFun(){
      //如果是后验证
      if(this.authStep=='after'){
        if (!document.querySelectorAll(".contract-img")[0]) {
          return;
        }
        //未指定签章位置时
        let sealMsg="";
        if(!this.positonExistFlag){
          //文件的索引
          let fileItemIndexList=[];
          document.querySelectorAll(".file-item").forEach((item,index)=>{
            fileItemIndexList.push(index+"")
          });
          // 章的索引
          let sealImgDataFileIndexList=[];
          document.querySelectorAll(".drag-overlay")[0].querySelectorAll(".seal-in").forEach((item,index)=>{
            sealImgDataFileIndexList.push(item.getAttribute('data-file'))
          })
          let bool=fileItemIndexList.every(item =>{
            return sealImgDataFileIndexList.indexOf(item) !== -1
          })
          if (!bool) {
            let msg="";
            // 创建一个新数组存放不重复的元素
            var resultArr = [];
            for (let i = 0; i < fileItemIndexList.length; i++) {
              if (!sealImgDataFileIndexList.includes(fileItemIndexList[i])) {
                resultArr.push(fileItemIndexList[i]);
              }
            }
            resultArr.map(it=>{
              msg+=`《${this.signFileInfoArray[it*1].fileName}》`
            })
            Dialog.alert({
              title: '温馨提示',
              message: `${msg}还没有盖章，请盖章后再次确认签署`,
              theme: 'round-button',
              confirmButtonText:'继续盖章',
              confirmButtonColor:'#3F7BF9'
            }).then(() => {
              // on close
            });
            return;
          }
          let fileItemDom=document.querySelectorAll(".drag-overlay");
          //如果主体是企业
          if(this.singVerifyForm.signSubject=='company'){
            for(let a=0;a<fileItemIndexList.length;a++){
             if(!Array.from(fileItemDom[0].querySelectorAll(".seal-in")).some(item=>{
                return  item.getAttribute("data-seal-type")=='companyCommon' && item.getAttribute("data-type")!='paging' && item.getAttribute('data-file')==fileItemIndexList[a]
              })){
               sealMsg+=`《${this.signFileInfoArray[fileItemIndexList[a*1]].fileName}》缺少【企业章】，请盖章后再次确认签署.`
             }
            }
          }
          if(this.singVerifyForm.signSubject=='person'){

            for(let a=0;a<fileItemIndexList.length;a++){
              if(!Array.from(fileItemDom[0].querySelectorAll(".seal-in")).some(item=>{
                return  item.getAttribute("data-seal-type")=='person' && item.getAttribute('data-file')==fileItemIndexList[a]
              })){
                sealMsg+=`《${this.signFileInfoArray[a].fileName}》缺少【个人章】，请盖章后再次确认签署.`
              }
            }
          }

          if(sealMsg){
            Dialog.alert({
              title: '温馨提示',
              message: sealMsg,
              theme: 'round-button',
              confirmButtonText:'继续盖章',
              confirmButtonColor:'#3F7BF9'
            }).then(() => {
              // on close
            });
            return;
          }
        }

        //指定了位置的
        if (this.positonExistFlag) {
          let flag=false;
          this.countPositionSealList.map(item=>{
            item.map(_item => {
              if (!_item.sealId) {
                //有未盖章的位置
                flag=true;
              }
            })
          })
          if(flag){
            let pageTitle="";
            let index=0;
            let fileItemDom=document.querySelectorAll(".file-item");

            for (let i=0;i<fileItemDom.length;i++){
              index=i;
              let pageIndex="";
              let pageIndexArr=[];
              this.countPositionSealList[i].map(_item => {
                if (!_item.sealId) {
                  if(!pageIndexArr.includes(_item.positionPage)){
                    pageIndexArr.push(_item.positionPage)
                  }
                  pageIndexArr.sort(function(a, b) {
                    return a - b;
                  });
                }
              })
              pageIndexArr.map(it=>{
                pageIndex+=`第${it}页`
              })
              if(pageIndexArr.length){
                pageTitle+=`《${this.signFileInfoArray[index].fileName}》的${pageIndex}`;
              }

            }
            Dialog.alert({
              title: '温馨提示',
              message: `${pageTitle}还没有盖章，请盖章后再次确认签署`,
              theme: 'round-button',
              confirmButtonText:'继续盖章',
              confirmButtonColor:'#3F7BF9'
            }).then(() => {
              // on close
            });
            return;
          }
        }
        this.authMethodTypeVisible=true;
      }else{
        this.handleSave();
      }
    },
    handleSave() {
      if (!document.querySelectorAll(".contract-img")[0]) {
        return;
      }
      //未指定签章位置时
      let sealMsg="";
      if(!this.positonExistFlag){

        //文件的索引
        let fileItemIndexList=[];
        document.querySelectorAll(".file-item").forEach((item,index)=>{
          fileItemIndexList.push(index+"")
        });
        // 章的索引
        let sealImgDataFileIndexList=[];
        document.querySelectorAll(".drag-overlay")[0].querySelectorAll(".seal-in").forEach((item,index)=>{
          sealImgDataFileIndexList.push(item.getAttribute('data-file'))
        })
        let bool=fileItemIndexList.every(item =>{
          return sealImgDataFileIndexList.indexOf(item) !== -1
        })
        if (!bool) {
          let msg="";
          // 创建一个新数组存放不重复的元素
          var resultArr = [];
          for (let i = 0; i < fileItemIndexList.length; i++) {
            if (!sealImgDataFileIndexList.includes(fileItemIndexList[i])) {
              resultArr.push(fileItemIndexList[i]);
            }
          }
          resultArr.map(it=>{
            msg+=`《${this.signFileInfoArray[it*1].fileName}》`
          })
          Dialog.alert({
            title: '温馨提示',
            message: `${msg}还没有盖章，请盖章后再次确认签署`,
            theme: 'round-button',
            confirmButtonText:'继续盖章',
            confirmButtonColor:'#3F7BF9'
          }).then(() => {
            // on close
          });
          return;
        }
        let fileItemDom=document.querySelectorAll(".drag-overlay");
        //如果主体是企业
        if(this.singVerifyForm.signSubject=='company'){
          for(let a=0;a<fileItemIndexList.length;a++){
            if(!Array.from(fileItemDom[0].querySelectorAll(".seal-in")).some(item=>{
              return  item.getAttribute("data-seal-type")=='companyCommon' && item.getAttribute("data-type")!='paging' && item.getAttribute('data-file')==fileItemIndexList[a]
            })){
              sealMsg+=`《${this.signFileInfoArray[fileItemIndexList[a*1]].fileName}》》缺少【企业章】，请盖章后再次确认签署.`
            }
          }
        }
        if(this.singVerifyForm.signSubject=='person'){
          for(let a=0;a<fileItemIndexList.length;a++){
            if(!Array.from(fileItemDom[0].querySelectorAll(".seal-in")).some(item=>{
              return  item.getAttribute("data-seal-type")=='person' && item.getAttribute('data-file')==fileItemIndexList[a]
            })){
              sealMsg+=`《${this.signFileInfoArray[a].fileName}》缺少【个人章】，请盖章后再次确认签署.`
            }
          }
        }
        if(sealMsg){
          Dialog.alert({
            title: '温馨提示',
            message: sealMsg,
            theme: 'round-button',
            confirmButtonText:'继续盖章',
            confirmButtonColor:'#3F7BF9'
          }).then(() => {
            // on close
          });
          return;
        }


      }
      //指定位置时
      if (this.positonExistFlag) {
        let flag=false;
        this.countPositionSealList.map(item=>{
          item.map(_item => {
            if (!_item.sealId) {
              //有未盖章的位置
              flag=true;
            }
          })
        })

        if(flag){
          let pageTitle="";
          let index=0;
          let fileItemDom=document.querySelectorAll(".file-item");
          for (let i=0;i<fileItemDom.length;i++){
            index=i;
            // break
            let pageIndex="";
            let pageIndexArr=[];
            this.countPositionSealList[i].map(_item => {
              if (!_item.sealId) {
                if(!pageIndexArr.includes(_item.positionPage)){
                  pageIndexArr.push(_item.positionPage)
                }
                pageIndexArr.sort(function(a, b) {
                  return a - b;
                });
              }

            })
            pageIndexArr.map(it=>{
              pageIndex+=`第${it}页`
            })
            if(pageIndexArr.length) {
              pageTitle += `《${this.signFileInfoArray[index].fileName}》的${pageIndex}`;
            }
          }
          Dialog.alert({
            title: '温馨提示',
            message: `${pageTitle}还没有盖章，请盖章后再次确认签署`,
            theme: 'round-button',
            confirmButtonText:'继续盖章',
            confirmButtonColor:'#3F7BF9'
          }).then(() => {
            // on close
          });
          return;
        }
      }
      let positionLocationList = [];
      //指定位置时
      if(this.positonExistFlag){
        this.countPositionSealList.map(item => {
          item.map(_item => {
            if (_item.sealId) {
              positionLocationList.push(_item);
            }
          })
        })
      }else{

        let contractWidth =
            +document
                .getElementById("contract-imgs")
                .getElementsByClassName("file-item")
                [this.active].getElementsByClassName("contract-img")[0].offsetWidth;
        let contractHeight =
            +document
                .getElementById("contract-imgs")
                .getElementsByClassName("file-item")
                [this.active].getElementsByClassName("contract-img")[0].offsetHeight;
        this.$refs.contractImg.querySelectorAll(".drag-box").forEach((item) => {
          let isPaging = item.getAttribute("data-type") == "paging";
          let obj = {
            sealId: item.getAttribute("data-seal-id"),
            sealType: item.getAttribute("data-seal-type"),
            sealLocationType: isPaging ? "paging" : "position"
          };
          if (this.positonExistFlag) {
            obj.positionId = item.parentNode.parentNode.getAttribute("data-pos-id");
          } else {
            obj.signFileId = this.signFileInfoArray[item.getAttribute("data-file")].signFileId;
            if (!isPaging) {
              obj.positionX = parseInt(
                  (+item.style.left.split("px")[0] / contractWidth) * 50000
              );
              obj.positionPage = +item.getAttribute("data-page") + 1;
            }
            obj.positionY = parseInt(
                (+item.style.top.split("px")[0] / contractHeight) * 50000
            );
          }
          // 非首页的骑缝章忽略掉，相当于去重
          if (!isPaging || (isPaging && item.getAttribute("data-page") == 0)) {
            positionLocationList.push(obj);
          }
        });
      }
      this.signLoading = true;
      this.positionSealArray = positionLocationList;

      signPcAndH5({
        authToken:this.authToken,
        sid: this.sid,
        positionSealArray: positionLocationList,
      }).
      then((res) => {
        this.$nextTick(() => {
          this.signLoading = false;
        });
        if (res.code != 200) {
          this.signFinishLoading = false;
          if(res.code==5002){
            this.signLayer=false;
            this.sidExpired=true;
          }else{
            Notify({
              message: res.message,
              type: "warning",
            });

          }

        } else {
          this.signSucceed = true;
          Notify({
            message: "签署成功！",
            type: "success"
          });

          this.signFinishLoading = false;
          this.showLocatePopoverNew=false;  //右下角定位icon隐藏
          this.showLocatePopover=false;//右下角定位icon隐藏
          this.qianshuzhuangtai=true;
          this.$forceUpdate();
          this.getTaskInfoApi();
        }
      })
          .catch((err) => {
            this.signFinishLoading = false;
            this.$nextTick(() => {
              this.signLoading = false;
            });
          });









    },
    //一键盖章
    handleAutoSeal() {
      let sealInfoArrayCopy = JSON.parse(JSON.stringify(this.sealOutArray));
      let arrayMap = {};
      // if (this.needHandwritten && this.$store.state.drawSeal) {
      //     sealInfoArrayCopy.push({
      //         sealImg: this.$store.state.drawSeal,
      //         sealType: "person",
      //         key: "custom" + Date.now(),
      //         sealId: this.$route.query.selfHandwriteSealId,
      //         sealName: "个人签名章"
      //     })
      // }
      sealInfoArrayCopy.map(item => {
        item.check = false;
        if (!arrayMap[item.sealType]) {
          arrayMap[item.sealType] = [item]
        } else {
          arrayMap[item.sealType].push(item)
        }
      })
      this.sealInfoArrayMapAutoSeal = arrayMap;
      this.showAutoSeal = true;
    },
    handleSelectAutoSeal(item, list) {
      list.map(_item => {
        _item.check = false;
      })
      item.check = true;
    },
    //未指定位置是 选择签章时逻辑
    handleSelectSealNoLocation(item, list,allList) {
      Object.keys(this.sealInfoArrayMapAutoSeal).map(key=>{
        this.sealInfoArrayMapAutoSeal[key].map(item => {
          item.check=false
        })
      })
      if(item.sealType!="companyCommon"){
        this.isPaging=false;
      }
      // list.map(_item => {
      //   _item.check = false;
      // })
      item.check = true;
    },
    // 指定位置时 一键盖章 自动盖章逻辑
    handleCheckAutoSeal() {
      this.sealInArray = [];
      let checkedSealList = [];
      const contractDom = document.querySelector(".contract-content");

      // 清空之前手动盖上的章
      // if (contractDom.querySelectorAll(".drag-box").length) {
      //   Array.from(contractDom.querySelectorAll(".drag-box")).forEach(item => {
      //     item.parentNode.parentNode.removeChild(item.parentNode);
      //   });
      // }
      Object.keys(this.sealInfoArrayMapAutoSeal).map(key => {
        this.sealInfoArrayMapAutoSeal[key].map(item => {
          if (item.check) {
            item.node = document.querySelector(".seal-group").querySelector(`.drag-box[data-seal-id="${item.sealId}"]`);
            checkedSealList.push(item);
          }
        })
      })
      if (!checkedSealList.length) {
        Notify({
          message: "请选择印章",
          type: "warning",
        });
        return;
      }
      // let positionBoxList = Array.from(document.querySelectorAll(".position-box"));
      let positionBoxList = Array.from(contractDom
          .querySelectorAll(".file-item")
          [this.active].querySelectorAll(".position-box"));
      checkedSealList.map(item => {
        positionBoxList.map(nodeItem => {
          if (nodeItem.getAttribute("data-seal-type") == item.sealType) {
            // 更新签框统计数组
            this.countPositionSealList[this.active].find(_item => {
              return _item.positionId === nodeItem.getAttribute("data-pos-id")
            }).sealId = item.sealId;
            this.notSealCount=this.notSealCountFun();


            let itemNodeClone = item.node.cloneNode(true);
            const posType = nodeItem.getAttribute("data-type");
            const pageIdx = nodeItem.getAttribute("data-page-idx");
            const posId = nodeItem.getAttribute("data-pos-id");
            const cloneWrapDom = document.createElement("div");
            cloneWrapDom.style.position = "relative";
            cloneWrapDom.style.left = "unset";
            cloneWrapDom.style.top = "unset";
            const deleteDom = document.createElement("i");
            deleteDom.setAttribute(
                "class",
                "van-icon van-icon-close"
            );
            deleteDom.addEventListener("click", (e) => {
              e.stopPropagation();
              if (posType == 'paging') {
                // 删除所有相同id的骑缝章
                const targetPagingId = posId;
                const allTargetPagingDoms = contractDom
                    .querySelectorAll(".file-item")
                    [this.active].querySelectorAll(
                    '.position-box[data-pos-id="' +
                    targetPagingId +
                    '"] .drag-box'
                );
                for (let i = 0; i < allTargetPagingDoms.length; i++) {
                  allTargetPagingDoms[i].parentNode.parentNode.parentNode.classList.remove("has-seal");
                  allTargetPagingDoms[i].parentNode.parentNode.removeChild(
                      allTargetPagingDoms[i].parentNode
                  );
                }
              } else {
                cloneWrapDom.parentNode.parentNode.classList.remove("has-seal");
                cloneWrapDom.parentNode.removeChild(cloneWrapDom);
              }
              const sealPosItemIdx = this.sealInArray.findIndex(_item => {
                return _item.positionId == posId;
              })
              if (sealPosItemIdx >= 0) {
                this.sealInArray.splice(sealPosItemIdx, 1);
              }
              // 更新签框统计数组
              this.countPositionSealList[this.active].find(item => {
                return item.positionId === posId;
              }).sealId = null;
              this.notSealCount=this.notSealCountFun();
            });
            cloneWrapDom.appendChild(deleteDom);
            cloneWrapDom.appendChild(itemNodeClone);
            if (nodeItem.querySelector(".drag-box")) {
              nodeItem.querySelector(".drag-box").parentNode.parentNode.removeChild(nodeItem.querySelector(".drag-box").parentNode);
            }
            nodeItem.classList.add("has-seal");
            nodeItem.lastElementChild.appendChild(cloneWrapDom);
            let handleSeal = {
              show: true,
              positionId: posId,
              sealId: item.sealId,
              sealType: item.sealType
            };

            if (posType != 'paging' || (posType == 'paging' && pageIdx == 0)) {
              this.sealInArray.push(handleSeal);
            }

          }
        })
      })
      this.showAutoSeal = false;
    },

    //未指定位置时  盖章
    handleCheckNoLocationSeal(){
      let checkedSealList = [];
      Object.keys(this.sealInfoArrayMapAutoSeal).map(key => {
        this.sealInfoArrayMapAutoSeal[key].map(item => {
          if (item.check) {
            checkedSealList.push(item);
          }
        })
      })
      if(!checkedSealList.length){
        Notify({
          type: "danger",
          message: "请选择印章"
        });
        return
      }

      checkedSealList.map(item=>{
        //章的宽度 高度  各取一半  中心点
        let sealWidth=0;
        let sealHeight=0;
        if(item.sealType=="companyCommon"){
          sealWidth=36;
          sealHeight=36;
        }else if(item.sealType=="person"){
          sealWidth=36;
          sealHeight=18;
        }else if(item.sealType=="companyLegal"){
          sealWidth=36;
          sealHeight=18;
        }else if(item.sealType=="companyAgent"){
          sealWidth=36;
          sealHeight=18;
        }else if(item.sealType=="date"){
          sealWidth=36;
          sealHeight=18;
        }
        let handleSeal = JSON.parse(JSON.stringify(item));
        handleSeal.show = true;
        handleSeal.sealType = item.sealType;
        handleSeal.page = null;
        handleSeal.fileIdx = this.active;
        handleSeal.absTop = null;
        handleSeal.dataFile = this.active;
        handleSeal.dataSealId = item.sealId;
        //10   img-wrap 距离左侧10px


        let imgWrapHeight=document.querySelectorAll(".file-item")[this.active].querySelectorAll(".img-wrap")[0].offsetHeight
        let imgWrapOffsetTopList=document.querySelectorAll(".file-item")[this.active].querySelectorAll(".img-wrap")
        //如果勾选了骑缝章
        if(handleSeal.sealType=="companyCommon" && this.isPaging){
          handleSeal.dataType="paging";
          const allPageDoms = document.querySelector("#contract-imgs")
              .querySelectorAll(".file-item")
              [this.active].querySelectorAll(".img-wrap");
          if(allPageDoms.length<2){
            Notify({
              message: "单页文件不支持加盖骑缝章",
              type: "warning",
            });
          }else{
            allPageDoms.forEach((it,i)=>{
              let obj=JSON.parse(JSON.stringify(handleSeal))
              obj.left =document.querySelector('.contract-wrap').offsetWidth-sealWidth-10;
             if((this.originTargetTop+this.$refs.contractImg.scrollTop)>imgWrapHeight+25){
                obj.top =(this.originTargetOffsetY-sealHeight)+ (imgWrapHeight +25)*i;
              }else{
                obj.top =(this.originTargetTop+this.$refs.contractImg.scrollTop-42-sealHeight)+ (imgWrapHeight +25)*i;
              }
             obj.rangeStart=imgWrapOffsetTopList[i].offsetTop;
             obj.rangeEnd=imgWrapOffsetTopList[i+1]?imgWrapOffsetTopList[i+1].offsetTop:imgWrapOffsetTopList[i].offsetTop+imgWrapHeight;

              if (obj.left <= this.$refs.contractImg.offsetWidth) {
                obj.dragKey = obj.sealId + this.sealInArray.length +i;
                this.sealInArray.push(obj);
              }
              this.judgePage(obj, obj.top,imgWrapHeight, sealHeight*2);
            })
            this.sealCount++;
          }


        }else{
          handleSeal.left =this.originTargetLeft-sealWidth-10;
          handleSeal.top =this.originTargetTop+this.$refs.contractImg.scrollTop-42-sealHeight;
          handleSeal.dataType="position"
          if (handleSeal.left <= this.$refs.contractImg.offsetWidth) {
            handleSeal.dragKey = handleSeal.sealId + this.sealInArray.length;
            this.sealInArray.push(handleSeal);
          }
          this.judgePage(handleSeal, handleSeal.top,imgWrapHeight , sealHeight*2);
          this.sealCount++;
        }

      })

      this.isPaging=false;
     this.showSealNoLocation=false;
    },


    handlePageUp() {
      this.handleChangeContractImg(0, true);
    },
    handlePageDown() {
      this.handleChangeContractImg(this.signFileInfoArray[this.active].fileImgArray.length - 1, true);
    },
    handleChangeContractImg(imgIdx,isIndicator,signFileId) {
      let gutterHeight = 0;
      if (document.querySelectorAll(".img-wrap")[1]) {
        gutterHeight = +window
            .getComputedStyle(document.querySelectorAll(".img-wrap")[1], null)
            .marginTop.split("px")[0];
      }
      this.scrollTarget = (parseFloat(getStyle(document.querySelectorAll(".file-item")[this.active].getElementsByClassName("img-wrap")[0], "height")) + gutterHeight) * imgIdx;
      // 当选中缩略图时，不依赖滚动监听
      if (!isIndicator) {
        this.scrollWatchStatus = false;
        this.signFileInfoArray[this.active].current = imgIdx
      }
      document
          .getElementById("contract-imgs")
          .getElementsByClassName("file-item")
          [this.active]
      document.getElementsByClassName("contract-content")[0].scrollTo({
        top: this.scrollTarget, behavior: 'smooth'
      });
    },
    scrollEventHandler(e) {
      let timeId;
      e = e || window.event;
      if (
          e.target.classList &&
          e.target.classList.contains("contract-content")
      ) {
        clearTimeout(timeId);
        timeId = setTimeout(() => {
          this.handleScroll();
        }, 100);
        // this.handleScroll();
      } else {
        clearTimeout(timeId);
      }
    },
    handleScroll() {
      // dom滚动位置
      let scrollTop =
          document.getElementsByClassName("contract-content")[0].scrollTop;
      if (this.scrollWatchStatus) {
        let scaleFactor = 1;
        this.signFileInfoArray[this.active].fileImgArray.map((v, i) => {
          let offsetTop = document
              .getElementById("contract-imgs")
              .getElementsByClassName("file-item")
              [this.active].getElementsByClassName("img-wrap")[i].offsetTop;
          // 获取监听元素本身高度
          let scrollHeight = document
              .getElementById("contract-imgs")
              .getElementsByClassName("file-item")
              [this.active].getElementsByClassName("img-wrap")[i].scrollHeight;
          if (
              (scrollTop*2) >= offsetTop &&
              (scrollTop*2) <= offsetTop + scrollHeight * scaleFactor
          ) {
            this.signFileInfoArray[this.active].current = i;
            this.fenyeInfoNumFun(i);
            this.$forceUpdate();
          }
        });
      }
    },
    //指定位置时  快速定位
    showLocatePopoverFalse() {
      this.showLocatePopover = false;
    },
    //快速定位未盖章的位置  指定位置
    handleQuickLocateNotSeal() {
      if (this.notSealCount) {
        // 根据top排序
        const targetDoms = document.getElementById("contract-imgs").querySelectorAll(".file-item")[this.active].querySelectorAll(".position-box:not(.has-seal)");
        const fullTargetDoms = document.getElementById("contract-imgs").querySelectorAll(".file-item")[this.active].querySelectorAll(".position-box");
        const sortedDomsByTop = Array.from(targetDoms).sort((prev, next) => {
          return prev.getBoundingClientRect().top - next.getBoundingClientRect().top;
        })
        const targetDom = sortedDomsByTop[0];
        // 让目标滚到屏幕中间
        const calcTop = targetDom.getBoundingClientRect().top + document.getElementsByClassName("contract-content")[0].scrollTop
            - (document.documentElement.offsetHeight / 2) + (targetDom.offsetHeight / 2);
        document.getElementsByClassName("contract-content")[0].scrollTo({
          top: calcTop, behavior: 'smooth'
        });
        Array.from(fullTargetDoms).map(_item => {
          if (_item.classList.contains("highlight")) {
            _item.classList.remove("highlight");
          }
        });
        setTimeout(() => {
          targetDom.classList.add("highlight");
        }, 100)

        // targetDom.focus();
      } else {
        // 如果已经全部落章了，则依次步进定位已落章的框
        const targetDoms = document.getElementById("contract-imgs").querySelectorAll(".file-item")[this.active].querySelectorAll(".position-box");
        const sortedDomsByTop = Array.from(targetDoms).sort((prev, next) => {
          return prev.getBoundingClientRect().top - next.getBoundingClientRect().top;
        });
        this.locatePositionBoxByStepIdx++;
        if (this.locatePositionBoxByStepIdx > sortedDomsByTop.length - 1) {
          this.locatePositionBoxByStepIdx = 0;
        }
        const targetDom = sortedDomsByTop[this.locatePositionBoxByStepIdx];
        // 让目标滚到屏幕中间
        const calcTop = targetDom.getBoundingClientRect().top + document.getElementsByClassName("contract-content")[0].scrollTop
            - (document.documentElement.offsetHeight / 2) + (targetDom.offsetHeight / 2);
        document.getElementsByClassName("contract-content")[0].scrollTo({
          top: calcTop, behavior: 'smooth'
        });
        Array.from(targetDoms).map(_item => {
          if (_item.classList.contains("highlight")) {
            _item.classList.remove("highlight");
          }
        });
        setTimeout(() => {
          targetDom.classList.add("highlight");
        }, 100)
        // targetDom.focus();
      }

    },

    //未定位时已拖拽的签章数量
    showLocatePopoverTrue() {
      this.showLocatePopoverNew = false;
    },
    //快速定位已盖章的位置
    handleQuickLocateSeal() {
      // 如果已经全部落章了，则依次步进定位已落章的框
      const targetDoms = document.getElementById("contract-imgs").querySelectorAll(".drag-overlay")[this.active].querySelectorAll('.seal-in');
      let newArr=[];
      targetDoms.forEach(item=>{
        if(item.getAttribute('data-type')=='paging'){
          let flag=false;
          newArr.forEach(it=>{
            if(it.getAttribute('data-type')=='paging'){
              flag=true
            }
          })
          if(!flag){
            newArr.push(item)
          }
        }else{
          newArr.push(item)
        }
      })
      const sortedDomsByTop = Array.from(newArr).sort((prev, next) => {
        return prev.getBoundingClientRect().top - next.getBoundingClientRect().top;
      });
      this.locateNotPositionBoxByStepIdx++;
      if (this.locateNotPositionBoxByStepIdx > sortedDomsByTop.length - 1) {
        this.locateNotPositionBoxByStepIdx = 0;
      }
      const targetDom = sortedDomsByTop[this.locateNotPositionBoxByStepIdx];
      if(!targetDom){return}
      // 让目标滚到屏幕中间
      const calcTop = targetDom.getBoundingClientRect().top + document.getElementsByClassName("contract-content")[0].scrollTop
          - (document.documentElement.offsetHeight / 2) + (targetDom.offsetHeight / 2);
      document.getElementsByClassName("contract-content")[0].scrollTo({
        top: calcTop, behavior: 'smooth'
      });
      Array.from(newArr).map(_item => {
        if (_item.classList.contains("highlight")) {
          _item.classList.remove("highlight");
        }
      });
      setTimeout(() => {
        targetDom.classList.add("highlight");
      }, 100)
      // targetDom.focus();


    },

    //未指定位置时  拖拽章
    onSealInStart(e) {
      this.dragSealInfo.startX = e.originalEvent.offsetX;
      this.dragSealInfo.startY = e.originalEvent.offsetY;
      this.contractImgScrollTop = this.$refs.contractImg.scrollTop;
      this.dragging = true;
    },
    onSealInMove() {
    },
    onSealInEnd(e) {

      let handleSeal = this.sealInArray[e.oldIndex];
      let imgWrapHeight=document.querySelectorAll(".file-item")[this.active].querySelectorAll(".img-wrap")[0].offsetHeight

      if(handleSeal.dataType=="paging"){
        // 如果 拖拽到第二页
        let h=e.originalEvent.changedTouches[0].clientY -
            this.dragSealInfo.startY -
            this.dragSealInfo.offsetY -42  +
            this.contractImgScrollTop;
        if(h>(handleSeal.rangeEnd-72-25) || h<handleSeal.rangeStart){
          return
        }else{
          let handleSealTop =
              e.originalEvent.changedTouches[0].clientY -
              this.dragSealInfo.startY -
              this.dragSealInfo.offsetY -42  +
              this.contractImgScrollTop;

          if (handleSealTop < 0) {
            handleSealTop = 0;
          }
          this.sealInArray.map((item,index)=>{
            if(item.dataType=="paging" && item.show){
              item.top=(handleSealTop- handleSeal.page*(imgWrapHeight+25)) + (imgWrapHeight+25)*index;
            }
          })
        }




      }else{
        handleSeal.left =
            e.originalEvent.changedTouches[0].clientX -
            this.dragSealInfo.startX;
        handleSeal.top =
            e.originalEvent.changedTouches[0].clientY -
            this.dragSealInfo.startY -
            this.dragSealInfo.offsetY +
            this.contractImgScrollTop;
        if (handleSeal.left < 0) {
          handleSeal.left = 0;
        }
        if (handleSeal.top < 0) {
          handleSeal.top = 0;
        }
        if (handleSeal.left > this.$refs.contractImg.offsetWidth - e.item.offsetWidth) {
          handleSeal.left = this.$refs.contractImg.offsetWidth - e.item.offsetWidth/2;
        }
      }


      let retTarget = this.judgePage(handleSeal, handleSeal.top, document.querySelectorAll(".file-item")[this.active].querySelectorAll(".img-wrap")[0].offsetHeight, e.item.offsetHeight/2);
      this.dragging = false;
    },

    handleRemoveSealInItem(element,eleIdx) {
      let arr=JSON.parse(JSON.stringify(this.sealInArray));
      if(element.dataType=="paging"){
        arr.map((item,index)=>{
          if(item.dataType=="paging"){
            item.show=false;
          }
        })
      }else{
        this.$set(arr[eleIdx], "show", false)
      }
      var newArray = arr.filter(function(item) {
        return item.show !== false;
      });
      this.sealInArray=newArray;

      //如果是骑缝章
      // if(element.dataType=="paging"){
      //   this.sealInArray.map((item,index)=>{
      //     if(item.dataType=="paging"){
      //       this.$set(this.sealInArray[index], "show", false)
      //     }
      //   })
      // }else{
      //   this.$set(this.sealInArray[eleIdx], "show", false)
      // }
      this.sealCount--;
    },


    handleConfirmSmsCode() {
      if (!this.value || this.value.length < 6) {
        return;
      } else {

      }
    },
    sendSms(){},
    switchWay(type) {
      this.value = "";
      this.pinValue = "";
      this.authPinSuccess = false;
      this.authSuccess = false;
      if (type == 'sms') {
        this.showPinDialog = false;
        this.showDialog = true;

        // this.sendSms();

      } else {
        this.showPinDialog = true;
        this.showDialog = false;
      }
    },
    handleIpt() {
      this.showKeyboard = true;
    },

    highlightEventHandler(e) {
      e = e || window.event;
      let target = e.target;
      while (
          target.tagName != "BODY" &&
          !String(target.className).includes("locate-indicator")
          ) {
        target = target.parentNode;
      }
      if (!String(target.className).includes("locate-indicator")) {
        Array.from(document.body.querySelectorAll(".highlight")).map(_item => {
          _item.classList.remove("highlight");
        });
      }
    },
    //顶部分页展示信息
    fenyeInfoNumFun(i){
      this.fenyeInfoNum=(i+1)+"/"+this.signFileInfoArray[this.active].fileImgArray.length;
    },

    handleBackHome() {
      // this.$router.replace("/");
      window.location.href=this.singVerifyForm.returnUrl;
    },
    handleNewHandwrite() {
      this.$router.push({
        path: "/app/handwrite?signId=" + this.signId
      });
    },
  },
  components: {
    draggable,
    [Button.name]:Button,[Form.name]:Form,[Field.name]:Field,[Icon.name]:Icon,[Popup.name]:Popup,[RadioGroup.name]:RadioGroup,[Radio.name]:Radio,[ActionSheet.name]:ActionSheet,[Overlay.name]:Overlay,[Loading.name]:Loading,[Uploader.name]:Uploader,[Checkbox.name]:Checkbox,[DatetimePicker.name]:DatetimePicker,[Image.name]:Image,[NavBar.name]:NavBar,[Picker.name]:Picker,[Calendar.name]:Calendar,[Cell.name]:Cell,[CellGroup.name]:CellGroup,[PasswordInput.name]:PasswordInput,[NumberKeyboard.name]:NumberKeyboard,[Dialog.Component.name]:Dialog.Component,[Tab.name]:Tab,[Tabs.name]:Tabs,[Swipe.name]:Swipe,[SwipeItem.name]:SwipeItem,[Tabbar.name]:Tabbar,[TabbarItem.name]:TabbarItem,[Toast.name]:Toast,[List.name]:List,[PullRefresh.name]:PullRefresh,[Badge.name]:Badge,[DropdownMenu.name]:DropdownMenu,[DropdownItem.name]:DropdownItem,[Switch.name]:Switch,[Divider.name]:Divider
  },
}
</script>
<style scoped src="@/assets/css/app.css"></style>
<style scoped lang="scss">
* {
  box-sizing: border-box;
  user-select: none;
}
.contract-wrap {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.contract-content {
  width: calc(100vw - 10px);
  //width: 100vw;
  position: absolute;
  top: 0;
  left: 10px;
  height: 100vh;
  overflow: auto;
  overflow-x: hidden;
  padding-bottom: 50px;
}

.img-wrap {
  position: relative;
  margin-bottom: 25px;
  box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
}


.contract-content .contract-img {
  width: 100%;
  height: auto;
  display: block;
  border-bottom: 1px solid #ddd;
}

// .delete-area {
//     width: 100vw;
//     height: 80px;
//     line-height: 80px;
//     position: absolute;
//     right: 0;
//     bottom: 0;
//     background-image: linear-gradient(rgb(255, 54, 54, 0),
//             rgb(255, 54, 54, 0.38));
//     text-align: center;
//     z-index: 19;
// }

.delete-area .van-icon {
  line-height: 80px;
}

.seal-group-wrap {
  width: 60px;
  height: 100vh;
  border-left: 1px solid #ddd;
  /* background: #eee; */
  position: fixed;
  right: 0;
  top: 0;
  font-size: .28rem;
  z-index: 19;
  padding-top: .2rem;
  padding-bottom: .2rem;
  // overflow-y: auto;
  display: none;
}
.seal-group {
  height: 100%;
  overflow-y: auto;
}

.seal-group ::v-deep div>span {
  display: flex;
  flex-direction: column;
  align-items: center;
}


.drag-overlay>span {
  width: calc(100vw - 0px);
  //height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  font-size: 0;
}

.seal-in {
  position: absolute;
  z-index: 10;
}

.seal-in {

  &[data-type='paging']{
    .van-icon {
      position: absolute;
      left: -8px;
      top: -8px;
    }
  }
  &.highlight {
    outline: 4px solid rgba(84, 137, 249, 0.2);
    transition: outline-width ease .1s;
  }

  .van-icon {
    position: absolute;
    right: -8px;
    top: -8px;
  }
}


/*被拖拽对象的样式*/
.seal-item {
  cursor: move;
  font-size: .24rem;
  text-align: center;
}

.seal-item+.seal-item {
  margin-top: .3rem;
}

.seal-item img {
  width: 56px;
  /* height: 56px; */
  height: auto;
  outline: 1px solid #aaa;
}

.seal-item .seal-title {
  margin-bottom: .1rem;
  font-size: 12px;
}

.seal-in img {
  width: 72px;
  /* height: 56px; */
  height: auto;
}

/*选中样式*/
.chosen {
  outline: solid 1px #3089dc !important;
  z-index: 29;
}

.bottom-btn{
  width: 100%;
  height: 70px;
  background-color: #fff;
  position: fixed;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  z-index: 999;
  border-top: 1px solid #EEEEEE;;
  text-align: center;

  .btn{
    width: 44%;
    margin-left: 4%;
    margin-top: 10px;
    border-radius: 8px;
    font-size: 15px;

  }
  .gaizhang{
    border: 1px solid #3F7BF9;
    color: #3F7BF9;
  }
  .queren{
    width: 80%;
  }
}

.pop-btn {
  width: 4rem;
  height: .7rem;
  position: absolute;
  left: 50%;
  bottom: .5rem;
  transform: translateX(-50%);
  z-index: 999;
}

.position-box {
  position: absolute;
  //overflow: hidden;
  &.highlight{
    outline: 4px solid rgba(84, 137, 249, 0.2);
    transition: outline-width ease .1s;
  }

   &[data-type="paging"] {
      border-radius: 2px 0 0 2px;
       border: 0.6px dashed #448DF7;
       background: rgba(68, 141, 247, 0.05);
       transition: outline-width ease .1s;
   }

  .sign-pos-box {
    width: 72px;
    height: 36px;
    border: 0.6px dashed #448DF7;
    background: rgba(68, 141, 247, 0.05);
    font-size: 0;
    // border-radius: 10px;
    // overflow: hidden;

    .drag-box {
      width: 100%;
      height: auto;
      position: relative;
      z-index: 9;
    }

    ::v-deep .van-icon {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 99;
      color: #ee0a24;
      font-size: 16px;
    }
  }

  .seal-pos-box {
    width: 72px;
    height: 72px;
    border: 0.6px dashed #448DF7;
    background: rgba(68, 141, 247, 0.05);
    //overflow: hidden;
    font-size: 0;
    border-radius: 2px;
  }
  .companyLegal-pos-box{
    width: 72px;
    height: 36px;
    border: 0.6px dashed #448DF7;
    background: rgba(68, 141, 247, 0.05);
    //overflow: hidden;
    font-size: 0;
    border-radius: 2px;
  }
  .companyLegal-pos-box img{
    display: block;
    margin: 0 auto;
    max-height: 36px;
  }

  .date-pos-box {
    // width: 128px;
    width: 72px;
    height: 20px;
    border: 0.6px dashed #448DF7;
    background: rgba(68, 141, 247, 0.05);
     border-radius: 2px;
    //overflow: hidden;
    font-size: 0;
  }

  .seal-pos-box img,

  .date-pos-box img {
    width: 100%;
  }

  .paging-pos-box img {
    width: 72px;
  }

  .seal-pos-box ::v-deep .van-icon,
  .companyLegal-pos-box ::v-deep .van-icon,
  .date-pos-box ::v-deep .van-icon {
    position: absolute;
    top: -8px;
    right: -8px;
    z-index: 99;
    color: #ee0a24;
    font-size: 16px;
  }
  .paging-pos-box ::v-deep .van-icon {
    position: absolute;
    top: -8px;
    left: -8px;
    z-index: 99;
    color: #ee0a24;
    font-size: 16px;
  }

  .paging-pos-box {
    // width: 50px;
    // height: 128px;
    width: 36px;
    height: 72px;
    //border: 1px solid #33cccc;
    //background: rgba(255, 255, 255, 0.7);
    // border-radius: 10px 0 0 10px;
    //overflow: hidden;

    ::v-deep .box-head {
      height: 72px;

      span {
        position: absolute;
        top: 40px;
        left: 4px;
        color: #aaa;
      }
    }
  }

  ::v-deep .box-head {
    width: 100%;
    height: 36px;
    color: #86909C;
    //background: #33cccc;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    //padding: 0 3px 0 8px;
    position: absolute;
    left: 50%;
    top: 48%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    .el-icon-close {
      cursor: pointer;
      padding: 5px;
    }
  }
  &.has-seal .box-head {
    display: none;
  }
}

.handwrite-add-btn {
  font-size: .24rem;
}

.handwrite-remove-btn {
  background: rgba(238, 10, 36, .1);
  color: rgba(238, 10, 36, .8);
  margin-top: .25rem;
}

.showTasks {
  z-index: 999;
  width: 100%;
  height: 42px;
  background: linear-gradient(0deg, #FFFFFF, #FFFFFF), #FFFFFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
  .left{
    display: flex;
    align-items: center;
    img {
      width: 14px;
      height:14px ;
      margin-right: 10px;
      margin-left: 10px;
    }
    span{
      align-self: center;
      font-size: 14px;
      color: #333;
    }
  }
  .right{
    display: flex;
    align-items: center;
    img {
      width: 10px;
      height: 5px;
      margin-right: 15px;
      margin-left: 10px;
    }
    span{
      align-self: center;
      font-size: 14px;
      color: #3F7BF9;
    }
  }
}
.closeTasks img {
  display: block;
  width: 0.4rem;
  transform: rotate(180deg);
}

.closeTasks {
  position: fixed;
  top: 4.85rem;
  left: 50%;
  margin-left: -0.9rem;
  width: 1.8rem;
  height: 0.63rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -0.9rem;
  background: #ffffff;
  border-radius: 0px 0px 0.2rem 0.2rem;
}

.task-list {
  width: calc(100% - 0.6rem);
  margin: 0 auto 0;
  font-size: 0.28rem;
  color: #333;
  .vanCellItem{
    height: 50px;
    line-height: 50px;
  }
}

.fenye{
  position: fixed;
  top: 50px;
  right: 20px;
  min-width: 45px;
  height: 19px;
  line-height: 19px;
  background-color: #000000;
  padding: 1px 8px;
  border-radius: 4px;
  z-index: 999;
  color: #ffffff;
  font-size: 12px;
  text-align: center;
}

.van-loading {
  margin-top: 40vh;
}

.seal-group .auto-seal-btn-wrap {
  margin-top: 35px;

  .van-button {
    padding: 0 4px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
}

.auto-seal-wrap {
  font-size: .25rem;
  padding: 0.4rem .6rem 1.5rem 0.6rem;

  .set-title {
    font-size: 15px;
    margin: 12px 0 12px 0;
    color: #313843;
    .qifengSwitch{
      display:flex;
      float:right;
      align-items: center;
      justify-items: center;
      .txt{
        padding-right: 10px;
      }

      ::v-deep .van-switch .van-switch__node{
        width: 16px;
        height: 16px;
        top: 1px;
      }
    }
  }


  .auto-seal-list {
    //display: grid;
    //grid-gap: 0.3rem;
    //grid-template-columns: repeat(auto-fit, 2.8rem);
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .seal-title {
      margin: 8px 0 16px 0;
      text-align: center;
    }
  }

  .auto-seal-item {
    //width: 2.8rem;
    //height: 2.8rem;
    border: 1px dashed #D8DAEA;
    border-radius: 5px;
    position: relative;
    cursor: pointer;
    //display: flex;
    align-items: center;
    text-align: center;

    .auto-seal-item-box{
      width: 100%;
      &[data-seal-type="companyCommon"] {
        //width: 2.8rem;
        //height: 2.8rem;
        height: 100%;
        padding: 16px;

      }
      &[data-seal-type="companyLegal"] {
        width: 100%;
        height: 72px;
        padding: 8px;
        img{
          max-height: 56px;
        }
      }
      &[data-seal-type="date"] {
        width: 100%;
        height: 44px;
        padding: 8px;
        img{
          max-height: 28px;
        }
      }
      &[data-seal-type="person"] {
        width: 100%;
        height: 72px;
        padding: 8px;
        img{
          max-height: 56px;
        }
      }

    }


    img {
      max-width: 100%;
      height: auto;
      vertical-align: middle;
      user-select: none;
    }

    &.isCheck {
      border: 1px solid #3F7BF9;
    }

    .check-icon {
      position: absolute;
      right: 0px;
      top: 0px;
      color: #409EFF;
      width: 26px;
      height: 26px;
    }
    .qifeng{
      width: 60px;
      height: 60px;
      position: absolute;
      top: 1px;
      right: 1px;
    }

  }



}

.gutter {
  display: block;
  height: 8px;
  background-color: #f7f8fa;
}




.agreement-text {
  color: #3296fa;
}

.sms-content {
  padding: 0.25rem 0;
}

.sms-content .van-password-input {
  margin: 0.25rem 0.3rem;
}

.sms-content .tip {
  text-align: center;

  &.send-sms {
    color: #3296fa;
    padding: 5px 24px 10px;
    text-decoration: underline;
  }
}

.sms-content .van-password-input {
  margin: 0.25rem 0.3rem;
}

.van-password-input .van-password-input__item {
  background: #f7f8fa;
  width: 50px;
  height: 50px;
  border-radius: 5px;
}

.sms-dialog ::v-deep .van-goods-action-button--warning {
  background: #dcdee0;
}

.van-dialog .tip {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0.33rem 24px 0.3rem;

  font-size: 0.26rem;
  font-weight: 500;
  color: #333333;

  a {
    color: #3296FA;
  }

  .van-checkbox {
    margin-right: .1rem;
  }
}

.switch-way {
  color: #3296fa;
  font-size: 14px;
  padding: 5px 24px 10px;
  text-decoration: underline;
}
//上下分页跳转
.page-indicator {
  // width: 32px;
  min-height: 32px;
  background: #FFFFFF;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #F2F2F3;
  position: fixed;
  bottom: 200px;
  right: 20px;
  z-index: 99;
  user-select: none;
  padding: 4px 0;

  cursor: pointer;

  .page-icon {
    padding: 4px 0;
    width: 32px;
    height: 24px;

    .page-icon-inner {
      display: block;
      margin: 0 auto;
    }

    .page-icon-inner.active {
      display: none;
    }

    &:hover {
      .page-icon-inner {
        display: none;
      }

      .page-icon-inner.active {
        display: block;
      }
    }
  }
}
// 签章数量
.locate-indicator {
  width: 32px;
  height: 32px;
  background: linear-gradient(180deg, #E5EEFF 0%, #FFFFFF 100%);
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #E4ECFF;

  position: fixed;
  bottom: 150px;
  right: 20px;
  z-index: 99;
  user-select: none;

  cursor: pointer;

  .badge {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: #EB6069;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.9);
    line-height: 20px;
    position: absolute;
    right: -10px;
    top: -10px;
  }

  .locate-icon {
    width: 32px;
    height: 32px;
  }

  .locate-icon-inner {
    display: block;
    margin: 0 auto;
  }

  .locate-icon-inner.active {
    display: none;
  }


  &:hover {
    .locate-icon-inner {
      display: none;
    }

    .locate-icon-inner.active {
      display: block;
    }
  }
}
//指定位置时  选择签章 弹窗
.coverSealDialog,.autoSealDialog{
  .head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 54px;
    background-color: #ffffff;
    border-bottom: 1px solid #F2F3F5;
    border-radius: 10px 10px 0px 0px;
    .left{
      display: flex;
      justify-content: left;
      align-items: center;
      .txt{
        margin-left: 16px;
        margin-right: 16px;
        color: #333333;
        font-size: 0.3rem;
      }
      .checkbox ::v-deep .van-checkbox__label{
         color: #666666 !important;
      }
    }
    .right{
      margin-right: 20px;
      color: #86909C;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .footer{
    background-color: #ffffff;
    border-top: 1px solid #eee;
    height: 70px;
    position: fixed;
    bottom: 0;
    width: 100%;
    .auto-seal-sure-btn {
      width: 80%;
      height: 0.7rem;
      margin: 15px auto;
      border-radius: 8px;

    }
  }
}
//未指定位置  选择签章 弹床

.noLocationSealDialog{
  .head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 54px;
    background-color: #ffffff;
    border-bottom: 1px solid #F2F3F5;
    border-radius: 10px 10px 0px 0px;
    .left{
      display: flex;
      justify-content: left;
      align-items: center;
      .txt{
        margin-left: 16px;
        margin-right: 16px;
        color: #333333;
        font-size: 0.3rem;
      }
      .checkbox ::v-deep .van-checkbox__label{
        color: #666666 !important;
      }
    }
    .right{
      margin-right: 20px;
      color: #86909C;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .footer{
    background-color: #ffffff;
    border-top: 1px solid #eee;
    height: 70px;
    position: fixed;
    bottom: 0;
    width: 100%;
    .auto-seal-sure-btn {
      width: 80%;
      height: 0.7rem;
      margin: 15px auto;
      border-radius: 8px;

    }
  }
}

.singVerify{
  background-color: #fff;
  min-height: 100vh;
  .signVerify-body{
    width: 100%;
    background: linear-gradient(270deg, #F7FAFF 0%, #EDF3FF 100%);
    box-sizing: border-box;
    font-size: 0;
    margin: 0 auto;
    .tiao{
      margin-bottom: 20px;
      width: 100%;
    }
    .zhutiImg{
      width: 72px;
      height: 22px;
      margin-left: 20px;
      margin-bottom: 20px;
    }
    .signVerify-form{
      font-size: 14px;
      padding: 0px 30px 20px 30px;
      border-bottom: 1px dashed #D8D8D8;
      ::v-deep .van-cell{
        background-color: transparent;
      }
      .qrcode-box{
        width: 160px;
        height: 160px;
        margin: 0 auto;
        position: relative;
        .code-img{
          width: 160px;
          height: 160px;
          vertical-align: baseline;
        }
        .mask{
          width: 160px;
          height: 160px;
          border-radius: 6px;
          background: rgba(255,255,255,0.9);
          margin: 0 auto;
          position: absolute;
          top: 0;
          left: 0;
          .icon{
            width: 36px;
            height: 36px;
            position: absolute;
            top: 50px;
            left: 60px;
          }

        }
        .success{
          border: 2px solid #38A65A;
          .txt{
            position: absolute;
            top: 90px;
            left: 57px;
            color: #38A65A
          }
        }
        .warning{
          border: 2px solid #EFB040;
          .txt{
            position: absolute;
            top: 90px;
            left: 36px;
            color: #EFB040
          }
        }
        .danger{
          border: 2px solid #D54941;
          .txt{
            position: absolute;
            top: 90px;
            left: 43px;
            color: #D54941;
            width: 70px;
            height: 44px;
            line-height: 22px;
            word-wrap: break-word;
          }
        }
      }
    }
  }
  .signVerify-footer{
    font-size: 16px;
    width: 100%;

    .authWaysBox{
      padding: 30px;
      .authWaysBox-title{
        margin-bottom: 30px;
        font-size: 17px;
        font-weight: 500;
      }
      .sms-input{
        height: 40px;
        border: 1px solid #E7E9EE;
        border-radius: 4px;
        padding-left: 10px;
      }
      .code-btn {
        position: absolute;
        right: 10px;
        //top: 0px;
        //height: 39px;
        .right-btn {
          color: #3F7BF9;
        }
        .icon{
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
      }
      .code-icon{
        position: absolute;
        right: 16px;
        top: 0px;
        .icon{
          width: 16px;
          height: 16px;
          vertical-align: middle;
          cursor: pointer;
        }
        .icon-noeye{
          width: 16px;
          height: 16px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .signVerifySubmitBtn{
        width: 80%;
        margin: 40px auto;
        border-radius: 8px;
      }
      .alert{
        color: #D54941;
        font-size: 12px;
        margin-top: 5px;
      }
      .liveBox{
        text-align: center;
        p{
          padding-bottom: 25px;
          font-size: 14px;
        }
        img {
          width: 100px;
          height: 100px;
        }
      }


      .otherAuthWay{
        .otherAuthWay-head{
          display: flex;
          align-items: center;
          justify-content: center;
          .title{
            vertical-align: -8%;
            margin: 0 19px;
            font-size: 12px;
            color: #D8D8D8;
          }
          .line{
            width: 82px;
            border-top: 1px solid #F2F3F5;
          }
        }
        .otherAuthWay-body{
          display: flex;
          //justify-items: left;
          justify-content: center;
          align-items: center;
          height: 44px;
          line-height: 44px;
          margin-top: 26px;
          .img{
            width: 12px;
            height: 14px;
            margin-right: 10px;
            cursor: pointer;
            margin-bottom: 1px;
            vertical-align: middle;
          }
          .img:hover{
            opacity: 0.8;
          }
          .txt{
            margin-right: 20px;
            //margin-left: 20px;
            color: #3F7BF9;
            font-size: 14px;
            cursor: pointer;
          }
          .txt:hover{
            opacity: 0.8;
          }
        }

      }
    }




    .wancheng{
      margin-top: 50px;
      text-align: center;
      img {
        width: 84px;
        height: 84px;
      }
      .txt{
        margin-top: 8px;
        margin-bottom: 24px;
      }
      .fanhui{
        width: 140px;
      }

    }
  }
}

.sidExpired{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  font-size: 20px;
  img{
    width: 84px;
    height: 84px;
  }
}
/*
后验证方式弹窗
*/
.authMethodType-dialog{
  background: linear-gradient(180deg, #E1EAFF 0%, #FFFFFF 22%, #FFFFFF 100%);
  border-radius: 10px;
  .dialog-title{
    padding: 20px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .dialog-content{
    .authMethodType-form{
      padding: 0 20px;
      .sms-input{
        height: 40px;
        border: 1px solid #E7E9EE;
        border-radius: 4px;
        padding-left: 10px;
      }
      .code-btn {
        position: absolute;
        right: 10px;
        //top: 0px;
        //height: 39px;
        .right-btn {
          color: #3F7BF9;
        }
        .icon{
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
      }
      .code-icon{
        position: absolute;
        right: 16px;
        top: 0px;
        .icon{
          width: 16px;
          height: 16px;
          vertical-align: middle;
          cursor: pointer;
        }
        .icon-noeye{
          width: 16px;
          height: 16px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .liveBox{
        text-align: center;
        p{
          padding-bottom: 25px;
          font-size: 14px;
        }
        img {
          width: 100px;
          height: 100px;
        }
      }
      .signVerifySubmitBtn{
        width: 100%;
        margin: 20px auto;
        border-radius: 8px;
      }
      .alert{
        color: #D54941;
        font-size: 12px;
        margin-top: 5px;
      }

      .otherAuthWay-body{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 44px;
        line-height: 44px;
        margin-bottom: 20px;
        .img{
          width: 12px;
          height: 14px;
          margin-right: 10px;
          cursor: pointer;
          margin-bottom: 1px;
          vertical-align: middle;
        }
        .img:hover{
          opacity: 0.8;
        }
        .txt{
          margin-right: 20px;
          //margin-left: 20px;
          color: #3F7BF9;
          font-size: 14px;
          cursor: pointer;
        }
        .txt:hover{
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
